(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6937],{

/***/ 24603:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19781);
var global = __webpack_require__(17854);
var isForced = __webpack_require__(54705);
var inheritIfRequired = __webpack_require__(79587);
var createNonEnumerableProperty = __webpack_require__(68880);
var defineProperty = (__webpack_require__(3070).f);
var getOwnPropertyNames = (__webpack_require__(8006).f);
var isRegExp = __webpack_require__(47850);
var toString = __webpack_require__(41340);
var getFlags = __webpack_require__(67066);
var stickyHelpers = __webpack_require__(52999);
var redefine = __webpack_require__(31320);
var fails = __webpack_require__(47293);
var has = __webpack_require__(86656);
var enforceInternalState = (__webpack_require__(29909).enforce);
var setSpecies = __webpack_require__(96340);
var wellKnownSymbol = __webpack_require__(5112);
var UNSUPPORTED_DOT_ALL = __webpack_require__(9441);
var UNSUPPORTED_NCG = __webpack_require__(38173);

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
// TODO: Use only propper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS &&
  (!CORRECT_NEW || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = string.charAt(index);
    if (chr === '\\') {
      result += chr + string.charAt(++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = string.charAt(index);
    if (chr === '\\') {
      chr = chr + string.charAt(++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (IS_NCG.test(string.slice(index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || has(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named.push([groupname, groupid]);
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = this instanceof RegExpWrapper;
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || pattern instanceof RegExpWrapper) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = 'flags' in rawPattern ? rawPattern.flags : getFlags.call(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString(pattern);
    flags = flags === undefined ? '' : toString(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
      dotAll = !!flags && flags.indexOf('s') > -1;
      if (dotAll) flags = flags.replace(/s/g, '');
    }

    rawFlags = flags;

    if (UNSUPPORTED_Y && 'sticky' in re1) {
      sticky = !!flags && flags.indexOf('y') > -1;
      if (sticky) flags = flags.replace(/y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  var proxy = function (key) {
    key in RegExpWrapper || defineProperty(RegExpWrapper, key, {
      configurable: true,
      get: function () { return NativeRegExp[key]; },
      set: function (it) { NativeRegExp[key] = it; }
    });
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxy(keys[index++]);
  }

  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  redefine(global, 'RegExp', RegExpWrapper);
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),

/***/ 28450:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19781);
var UNSUPPORTED_DOT_ALL = __webpack_require__(9441);
var defineProperty = (__webpack_require__(3070).f);
var getInternalState = (__webpack_require__(29909).get);
var RegExpPrototype = RegExp.prototype;

// `RegExp.prototype.dotAll` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.dotall
if (DESCRIPTORS && UNSUPPORTED_DOT_ALL) {
  defineProperty(RegExpPrototype, 'dotAll', {
    configurable: true,
    get: function () {
      if (this === RegExpPrototype) return undefined;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (this instanceof RegExp) {
        return !!getInternalState(this).dotAll;
      }
      throw TypeError('Incompatible receiver, RegExp required');
    }
  });
}


/***/ }),

/***/ 88386:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19781);
var UNSUPPORTED_Y = (__webpack_require__(52999).UNSUPPORTED_Y);
var defineProperty = (__webpack_require__(3070).f);
var getInternalState = (__webpack_require__(29909).get);
var RegExpPrototype = RegExp.prototype;

// `RegExp.prototype.sticky` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.sticky
if (DESCRIPTORS && UNSUPPORTED_Y) {
  defineProperty(RegExpPrototype, 'sticky', {
    configurable: true,
    get: function () {
      if (this === RegExpPrototype) return undefined;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (this instanceof RegExp) {
        return !!getInternalState(this).sticky;
      }
      throw TypeError('Incompatible receiver, RegExp required');
    }
  });
}


/***/ }),

/***/ 4723:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(27007);
var anObject = __webpack_require__(19670);
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var requireObjectCoercible = __webpack_require__(84488);
var advanceStringIndex = __webpack_require__(31530);
var regExpExec = __webpack_require__(97651);

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ 83510:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__(97235);

// `Symbol.replace` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.replace
defineWellKnownSymbol('replace');


/***/ }),

/***/ 42118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(41848),
    baseIsNaN = __webpack_require__(62722),
    strictIndexOf = __webpack_require__(42351);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ 62722:
/***/ (function(module) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ 47415:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),

/***/ 42351:
/***/ (function(module) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ 64721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(42118),
    isArrayLike = __webpack_require__(98612),
    isString = __webpack_require__(47037),
    toInteger = __webpack_require__(40554),
    values = __webpack_require__(52628);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),

/***/ 41609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseKeys = __webpack_require__(280),
    getTag = __webpack_require__(64160),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isArrayLike = __webpack_require__(98612),
    isBuffer = __webpack_require__(44144),
    isPrototype = __webpack_require__(25726),
    isTypedArray = __webpack_require__(36719);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),

/***/ 47037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isArray = __webpack_require__(1469),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ 10928:
/***/ (function(module) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ 52628:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseValues = __webpack_require__(47415),
    keys = __webpack_require__(3674);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),

/***/ 16937:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ Input_Input; }
});

// UNUSED EXPORTS: Input, Suggestion

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.async-iterator.js
var es_symbol_async_iterator = __webpack_require__(72443);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-string-tag.js
var es_symbol_to_string_tag = __webpack_require__(39341);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(89554);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__(82772);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reverse.js
var es_array_reverse = __webpack_require__(65069);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.json.to-string-tag.js
var es_json_to_string_tag = __webpack_require__(73706);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.to-string-tag.js
var es_math_to_string_tag = __webpack_require__(10408);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(19601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-property.js
var es_object_define_property = __webpack_require__(69070);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(30489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__(68304);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(88674);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(77601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/node_modules/use-debounce/dist/index.module.js
function c(e,u,c){var i=this,a=(0,react.useRef)(null),o=(0,react.useRef)(0),f=(0,react.useRef)(null),l=(0,react.useRef)([]),v=(0,react.useRef)(),m=(0,react.useRef)(),d=(0,react.useRef)(e),g=(0,react.useRef)(!0);d.current=e;var p="undefined"!=typeof window,w=!u&&0!==u&&p;if("function"!=typeof e)throw new TypeError("Expected a function");u=+u||0;var s=!!(c=c||{}).leading,x=!("trailing"in c)||!!c.trailing,h="maxWait"in c,y="debounceOnServer"in c&&!!c.debounceOnServer,F=h?Math.max(+c.maxWait||0,u):null;(0,react.useEffect)(function(){return g.current=!0,function(){g.current=!1}},[]);var A=(0,react.useMemo)(function(){var r=function(r){var n=l.current,t=v.current;return l.current=v.current=null,o.current=r,m.current=d.current.apply(t,n)},n=function(r,n){w&&cancelAnimationFrame(f.current),f.current=w?requestAnimationFrame(r):setTimeout(r,n)},t=function(r){if(!g.current)return!1;var n=r-a.current;return!a.current||n>=u||n<0||h&&r-o.current>=F},e=function(n){return f.current=null,x&&l.current?r(n):(l.current=v.current=null,m.current)},c=function r(){var c=Date.now();if(t(c))return e(c);if(g.current){var i=u-(c-a.current),f=h?Math.min(i,F-(c-o.current)):i;n(r,f)}},A=function(){if(p||y){var e=Date.now(),d=t(e);if(l.current=[].slice.call(arguments),v.current=i,a.current=e,d){if(!f.current&&g.current)return o.current=a.current,n(c,u),s?r(a.current):m.current;if(h)return n(c,u),r(a.current)}return f.current||n(c,u),m.current}};return A.cancel=function(){f.current&&(w?cancelAnimationFrame(f.current):clearTimeout(f.current)),o.current=0,l.current=a.current=v.current=f.current=null},A.isPending=function(){return!!f.current},A.flush=function(){return f.current?e(Date.now()):m.current},A},[s,h,u,F,x,w,p,y]);return A}function i(r,n){return r===n}function a(r,n){return n}function o(n,t,o){var f=o&&o.equalityFn||i,l=e(a,n),v=l[0],m=l[1],d=c(u(function(r){return m(r)},[m]),t,o),g=r(n);return f(g.current,n)||(d(n),g.current=n),[v,d]}function f(r,n,t){var e=void 0===t?{}:t,u=e.leading,i=e.trailing;return c(r,n,{maxWait:n,leading:void 0===u||u,trailing:void 0===i||i})}
//# sourceMappingURL=index.module.js.map

// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/complex/ErrorPrompt/ErrorPrompt.mjs
var ErrorPrompt = __webpack_require__(6023);
// EXTERNAL MODULE: ./node_modules/lodash/last.js
var last = __webpack_require__(10928);
// EXTERNAL MODULE: ./node_modules/lodash/includes.js
var includes = __webpack_require__(64721);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.replace.js
var es_symbol_replace = __webpack_require__(83510);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__(69600);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__(85827);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.json.stringify.js
var es_json_stringify = __webpack_require__(38862);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.to-fixed.js
var es_number_to_fixed = __webpack_require__(56977);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.parse-float.js
var es_parse_float = __webpack_require__(54678);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__(24603);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.dot-all.js
var es_regexp_dot_all = __webpack_require__(28450);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.sticky.js
var es_regexp_sticky = __webpack_require__(88386);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(4723);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(15306);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.weak-map.js
var es_weak_map = __webpack_require__(4129);
// EXTERNAL MODULE: ./node_modules/mailcheck/src/mailcheck.js
var mailcheck = __webpack_require__(62320);
// EXTERNAL MODULE: ./node_modules/libphonenumber-js/min/exports/parsePhoneNumber.js + 2 modules
var parsePhoneNumber = __webpack_require__(75565);
// EXTERNAL MODULE: ./node_modules/libphonenumber-js/min/exports/AsYouType.js + 8 modules
var AsYouType = __webpack_require__(5559);
// EXTERNAL MODULE: ./node_modules/validator/lib/isEmail.js
var isEmail = __webpack_require__(83868);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/helpers/currencyHelpers.mjs
var currencyHelpers = __webpack_require__(97166);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Input/helpers.mjs
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }



function cov_25bxqxe5o4() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Input/helpers.ts";
  var hash = "9061f879f06d761431a15347495d4a2fae637557";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Input/helpers.ts",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 40
        },
        end: {
          line: 10,
          column: 76
        }
      },
      "1": {
        start: {
          line: 12,
          column: 43
        },
        end: {
          line: 12,
          column: 52
        }
      },
      "2": {
        start: {
          line: 14,
          column: 28
        },
        end: {
          line: 14,
          column: 37
        }
      },
      "3": {
        start: {
          line: 15,
          column: 37
        },
        end: {
          line: 15,
          column: 57
        }
      },
      "4": {
        start: {
          line: 16,
          column: 34
        },
        end: {
          line: 16,
          column: 63
        }
      },
      "5": {
        start: {
          line: 18,
          column: 39
        },
        end: {
          line: 39,
          column: 1
        }
      },
      "6": {
        start: {
          line: 41,
          column: 32
        },
        end: {
          line: 41,
          column: 76
        }
      },
      "7": {
        start: {
          line: 43,
          column: 21
        },
        end: {
          line: 59,
          column: 1
        }
      },
      "8": {
        start: {
          line: 44,
          column: 2
        },
        end: {
          line: 58,
          column: 5
        }
      },
      "9": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 57,
          column: 7
        }
      },
      "10": {
        start: {
          line: 48,
          column: 19
        },
        end: {
          line: 48,
          column: 30
        }
      },
      "11": {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 54,
          column: 9
        }
      },
      "12": {
        start: {
          line: 51,
          column: 10
        },
        end: {
          line: 51,
          column: 77
        }
      },
      "13": {
        start: {
          line: 53,
          column: 10
        },
        end: {
          line: 53,
          column: 22
        }
      },
      "14": {
        start: {
          line: 61,
          column: 34
        },
        end: {
          line: 67,
          column: 1
        }
      },
      "15": {
        start: {
          line: 64,
          column: 16
        },
        end: {
          line: 64,
          column: 85
        }
      },
      "16": {
        start: {
          line: 65,
          column: 21
        },
        end: {
          line: 65,
          column: 46
        }
      },
      "17": {
        start: {
          line: 66,
          column: 2
        },
        end: {
          line: 66,
          column: 31
        }
      },
      "18": {
        start: {
          line: 69,
          column: 32
        },
        end: {
          line: 72,
          column: 1
        }
      },
      "19": {
        start: {
          line: 70,
          column: 16
        },
        end: {
          line: 70,
          column: 55
        }
      },
      "20": {
        start: {
          line: 71,
          column: 2
        },
        end: {
          line: 71,
          column: 34
        }
      },
      "21": {
        start: {
          line: 74,
          column: 35
        },
        end: {
          line: 89,
          column: 1
        }
      },
      "22": {
        start: {
          line: 79,
          column: 14
        },
        end: {
          line: 79,
          column: 18
        }
      },
      "23": {
        start: {
          line: 80,
          column: 20
        },
        end: {
          line: 80,
          column: 73
        }
      },
      "24": {
        start: {
          line: 81,
          column: 19
        },
        end: {
          line: 81,
          column: 40
        }
      },
      "25": {
        start: {
          line: 82,
          column: 2
        },
        end: {
          line: 84,
          column: 3
        }
      },
      "26": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 18
        }
      },
      "27": {
        start: {
          line: 85,
          column: 2
        },
        end: {
          line: 87,
          column: 3
        }
      },
      "28": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 18
        }
      },
      "29": {
        start: {
          line: 88,
          column: 2
        },
        end: {
          line: 88,
          column: 15
        }
      },
      "30": {
        start: {
          line: 91,
          column: 29
        },
        end: {
          line: 102,
          column: 1
        }
      },
      "31": {
        start: {
          line: 92,
          column: 20
        },
        end: {
          line: 92,
          column: 73
        }
      },
      "32": {
        start: {
          line: 93,
          column: 18
        },
        end: {
          line: 93,
          column: 62
        }
      },
      "33": {
        start: {
          line: 97,
          column: 26
        },
        end: {
          line: 100,
          column: 71
        }
      },
      "34": {
        start: {
          line: 101,
          column: 2
        },
        end: {
          line: 101,
          column: 25
        }
      },
      "35": {
        start: {
          line: 104,
          column: 28
        },
        end: {
          line: 114,
          column: 1
        }
      },
      "36": {
        start: {
          line: 105,
          column: 20
        },
        end: {
          line: 105,
          column: 73
        }
      },
      "37": {
        start: {
          line: 106,
          column: 18
        },
        end: {
          line: 106,
          column: 62
        }
      },
      "38": {
        start: {
          line: 110,
          column: 26
        },
        end: {
          line: 112,
          column: 65
        }
      },
      "39": {
        start: {
          line: 113,
          column: 2
        },
        end: {
          line: 113,
          column: 25
        }
      },
      "40": {
        start: {
          line: 116,
          column: 35
        },
        end: {
          line: 120,
          column: 1
        }
      },
      "41": {
        start: {
          line: 118,
          column: 19
        },
        end: {
          line: 118,
          column: 84
        }
      },
      "42": {
        start: {
          line: 119,
          column: 2
        },
        end: {
          line: 119,
          column: 61
        }
      },
      "43": {
        start: {
          line: 122,
          column: 27
        },
        end: {
          line: 162,
          column: 1
        }
      },
      "44": {
        start: {
          line: 123,
          column: 17
        },
        end: {
          line: 123,
          column: 20
        }
      },
      "45": {
        start: {
          line: 124,
          column: 2
        },
        end: {
          line: 126,
          column: 3
        }
      },
      "46": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 125,
          column: 20
        }
      },
      "47": {
        start: {
          line: 128,
          column: 2
        },
        end: {
          line: 160,
          column: 3
        }
      },
      "48": {
        start: {
          line: 132,
          column: 6
        },
        end: {
          line: 148,
          column: 7
        }
      },
      "49": {
        start: {
          line: 140,
          column: 10
        },
        end: {
          line: 140,
          column: 94
        }
      },
      "50": {
        start: {
          line: 142,
          column: 8
        },
        end: {
          line: 142,
          column: 55
        }
      },
      "51": {
        start: {
          line: 143,
          column: 22
        },
        end: {
          line: 143,
          column: 43
        }
      },
      "52": {
        start: {
          line: 144,
          column: 8
        },
        end: {
          line: 147,
          column: 9
        }
      },
      "53": {
        start: {
          line: 145,
          column: 65
        },
        end: {
          line: 145,
          column: 77
        }
      },
      "54": {
        start: {
          line: 146,
          column: 10
        },
        end: {
          line: 146,
          column: 73
        }
      },
      "55": {
        start: {
          line: 149,
          column: 6
        },
        end: {
          line: 149,
          column: 12
        }
      },
      "56": {
        start: {
          line: 151,
          column: 6
        },
        end: {
          line: 151,
          column: 56
        }
      },
      "57": {
        start: {
          line: 152,
          column: 6
        },
        end: {
          line: 152,
          column: 12
        }
      },
      "58": {
        start: {
          line: 154,
          column: 6
        },
        end: {
          line: 154,
          column: 55
        }
      },
      "59": {
        start: {
          line: 155,
          column: 6
        },
        end: {
          line: 155,
          column: 12
        }
      },
      "60": {
        start: {
          line: 157,
          column: 6
        },
        end: {
          line: 157,
          column: 66
        }
      },
      "61": {
        start: {
          line: 158,
          column: 6
        },
        end: {
          line: 158,
          column: 12
        }
      },
      "62": {
        start: {
          line: 161,
          column: 2
        },
        end: {
          line: 161,
          column: 18
        }
      },
      "63": {
        start: {
          line: 164,
          column: 31
        },
        end: {
          line: 167,
          column: 1
        }
      },
      "64": {
        start: {
          line: 165,
          column: 23
        },
        end: {
          line: 165,
          column: 90
        }
      },
      "65": {
        start: {
          line: 166,
          column: 2
        },
        end: {
          line: 166,
          column: 33
        }
      },
      "66": {
        start: {
          line: 169,
          column: 29
        },
        end: {
          line: 191,
          column: 1
        }
      },
      "67": {
        start: {
          line: 170,
          column: 17
        },
        end: {
          line: 170,
          column: 20
        }
      },
      "68": {
        start: {
          line: 171,
          column: 2
        },
        end: {
          line: 173,
          column: 3
        }
      },
      "69": {
        start: {
          line: 172,
          column: 4
        },
        end: {
          line: 172,
          column: 20
        }
      },
      "70": {
        start: {
          line: 175,
          column: 2
        },
        end: {
          line: 189,
          column: 3
        }
      },
      "71": {
        start: {
          line: 178,
          column: 26
        },
        end: {
          line: 178,
          column: 68
        }
      },
      "72": {
        start: {
          line: 179,
          column: 6
        },
        end: {
          line: 179,
          column: 75
        }
      },
      "73": {
        start: {
          line: 180,
          column: 6
        },
        end: {
          line: 180,
          column: 12
        }
      },
      "74": {
        start: {
          line: 182,
          column: 6
        },
        end: {
          line: 182,
          column: 50
        }
      },
      "75": {
        start: {
          line: 183,
          column: 6
        },
        end: {
          line: 183,
          column: 12
        }
      },
      "76": {
        start: {
          line: 186,
          column: 6
        },
        end: {
          line: 186,
          column: 74
        }
      },
      "77": {
        start: {
          line: 187,
          column: 6
        },
        end: {
          line: 187,
          column: 12
        }
      },
      "78": {
        start: {
          line: 190,
          column: 2
        },
        end: {
          line: 190,
          column: 18
        }
      },
      "79": {
        start: {
          line: 201,
          column: 49
        },
        end: {
          line: 206,
          column: 1
        }
      },
      "80": {
        start: {
          line: 202,
          column: 23
        },
        end: {
          line: 202,
          column: 61
        }
      },
      "81": {
        start: {
          line: 204,
          column: 4
        },
        end: {
          line: 204,
          column: 93
        }
      },
      "82": {
        start: {
          line: 205,
          column: 2
        },
        end: {
          line: 205,
          column: 44
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 43,
            column: 21
          },
          end: {
            line: 43,
            column: 22
          }
        },
        loc: {
          start: {
            line: 43,
            column: 57
          },
          end: {
            line: 59,
            column: 1
          }
        },
        line: 43
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 44,
            column: 21
          },
          end: {
            line: 44,
            column: 22
          }
        },
        loc: {
          start: {
            line: 44,
            column: 34
          },
          end: {
            line: 58,
            column: 3
          }
        },
        line: 44
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 48,
            column: 13
          },
          end: {
            line: 48,
            column: 14
          }
        },
        loc: {
          start: {
            line: 48,
            column: 19
          },
          end: {
            line: 48,
            column: 30
          }
        },
        line: 48
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 49,
            column: 17
          },
          end: {
            line: 49,
            column: 18
          }
        },
        loc: {
          start: {
            line: 49,
            column: 33
          },
          end: {
            line: 55,
            column: 7
          }
        },
        line: 49
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 61,
            column: 34
          },
          end: {
            line: 61,
            column: 35
          }
        },
        loc: {
          start: {
            line: 63,
            column: 54
          },
          end: {
            line: 67,
            column: 1
          }
        },
        line: 63
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 69,
            column: 32
          },
          end: {
            line: 69,
            column: 33
          }
        },
        loc: {
          start: {
            line: 69,
            column: 60
          },
          end: {
            line: 72,
            column: 1
          }
        },
        line: 69
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 74,
            column: 35
          },
          end: {
            line: 74,
            column: 36
          }
        },
        loc: {
          start: {
            line: 78,
            column: 14
          },
          end: {
            line: 89,
            column: 1
          }
        },
        line: 78
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 91,
            column: 29
          },
          end: {
            line: 91,
            column: 30
          }
        },
        loc: {
          start: {
            line: 91,
            column: 79
          },
          end: {
            line: 102,
            column: 1
          }
        },
        line: 91
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 104,
            column: 28
          },
          end: {
            line: 104,
            column: 29
          }
        },
        loc: {
          start: {
            line: 104,
            column: 78
          },
          end: {
            line: 114,
            column: 1
          }
        },
        line: 104
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 116,
            column: 35
          },
          end: {
            line: 116,
            column: 36
          }
        },
        loc: {
          start: {
            line: 116,
            column: 85
          },
          end: {
            line: 120,
            column: 1
          }
        },
        line: 116
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 122,
            column: 27
          },
          end: {
            line: 122,
            column: 28
          }
        },
        loc: {
          start: {
            line: 122,
            column: 89
          },
          end: {
            line: 162,
            column: 1
          }
        },
        line: 122
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 164,
            column: 31
          },
          end: {
            line: 164,
            column: 32
          }
        },
        loc: {
          start: {
            line: 164,
            column: 58
          },
          end: {
            line: 167,
            column: 1
          }
        },
        line: 164
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 169,
            column: 29
          },
          end: {
            line: 169,
            column: 30
          }
        },
        loc: {
          start: {
            line: 169,
            column: 68
          },
          end: {
            line: 191,
            column: 1
          }
        },
        line: 169
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 201,
            column: 49
          },
          end: {
            line: 201,
            column: 50
          }
        },
        loc: {
          start: {
            line: 201,
            column: 76
          },
          end: {
            line: 206,
            column: 1
          }
        },
        line: 201
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 54,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 54,
            column: 9
          }
        }, {
          start: {
            line: 52,
            column: 15
          },
          end: {
            line: 54,
            column: 9
          }
        }],
        line: 50
      },
      "1": {
        loc: {
          start: {
            line: 64,
            column: 16
          },
          end: {
            line: 64,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 64,
            column: 16
          },
          end: {
            line: 64,
            column: 67
          }
        }, {
          start: {
            line: 64,
            column: 71
          },
          end: {
            line: 64,
            column: 85
          }
        }],
        line: 64
      },
      "2": {
        loc: {
          start: {
            line: 71,
            column: 9
          },
          end: {
            line: 71,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 71,
            column: 9
          },
          end: {
            line: 71,
            column: 14
          }
        }, {
          start: {
            line: 71,
            column: 18
          },
          end: {
            line: 71,
            column: 33
          }
        }],
        line: 71
      },
      "3": {
        loc: {
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 82,
            column: 2
          },
          end: {
            line: 84,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 82
      },
      "4": {
        loc: {
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 82,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 82,
            column: 6
          },
          end: {
            line: 82,
            column: 14
          }
        }, {
          start: {
            line: 82,
            column: 18
          },
          end: {
            line: 82,
            column: 37
          }
        }],
        line: 82
      },
      "5": {
        loc: {
          start: {
            line: 85,
            column: 2
          },
          end: {
            line: 87,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 2
          },
          end: {
            line: 87,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 85
      },
      "6": {
        loc: {
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 85,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 85,
            column: 14
          }
        }, {
          start: {
            line: 85,
            column: 18
          },
          end: {
            line: 85,
            column: 37
          }
        }],
        line: 85
      },
      "7": {
        loc: {
          start: {
            line: 100,
            column: 12
          },
          end: {
            line: 100,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 100,
            column: 41
          },
          end: {
            line: 100,
            column: 42
          }
        }, {
          start: {
            line: 100,
            column: 45
          },
          end: {
            line: 100,
            column: 70
          }
        }],
        line: 100
      },
      "8": {
        loc: {
          start: {
            line: 112,
            column: 12
          },
          end: {
            line: 112,
            column: 64
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 112,
            column: 41
          },
          end: {
            line: 112,
            column: 42
          }
        }, {
          start: {
            line: 112,
            column: 45
          },
          end: {
            line: 112,
            column: 64
          }
        }],
        line: 112
      },
      "9": {
        loc: {
          start: {
            line: 124,
            column: 2
          },
          end: {
            line: 126,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 124,
            column: 2
          },
          end: {
            line: 126,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 124
      },
      "10": {
        loc: {
          start: {
            line: 124,
            column: 6
          },
          end: {
            line: 124,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 124,
            column: 6
          },
          end: {
            line: 124,
            column: 15
          }
        }, {
          start: {
            line: 124,
            column: 19
          },
          end: {
            line: 124,
            column: 40
          }
        }],
        line: 124
      },
      "11": {
        loc: {
          start: {
            line: 128,
            column: 2
          },
          end: {
            line: 160,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 130,
            column: 4
          },
          end: {
            line: 149,
            column: 12
          }
        }, {
          start: {
            line: 150,
            column: 4
          },
          end: {
            line: 152,
            column: 12
          }
        }, {
          start: {
            line: 153,
            column: 4
          },
          end: {
            line: 155,
            column: 12
          }
        }, {
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 158,
            column: 12
          }
        }, {
          start: {
            line: 159,
            column: 4
          },
          end: {
            line: 159,
            column: 12
          }
        }],
        line: 128
      },
      "12": {
        loc: {
          start: {
            line: 132,
            column: 6
          },
          end: {
            line: 148,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 132,
            column: 6
          },
          end: {
            line: 148,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 132
      },
      "13": {
        loc: {
          start: {
            line: 132,
            column: 12
          },
          end: {
            line: 132,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 132,
            column: 12
          },
          end: {
            line: 132,
            column: 31
          }
        }, {
          start: {
            line: 132,
            column: 35
          },
          end: {
            line: 132,
            column: 55
          }
        }],
        line: 132
      },
      "14": {
        loc: {
          start: {
            line: 144,
            column: 8
          },
          end: {
            line: 147,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 144,
            column: 8
          },
          end: {
            line: 147,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 144
      },
      "15": {
        loc: {
          start: {
            line: 171,
            column: 2
          },
          end: {
            line: 173,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 171,
            column: 2
          },
          end: {
            line: 173,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 171
      },
      "16": {
        loc: {
          start: {
            line: 171,
            column: 6
          },
          end: {
            line: 171,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 171,
            column: 6
          },
          end: {
            line: 171,
            column: 15
          }
        }, {
          start: {
            line: 171,
            column: 19
          },
          end: {
            line: 171,
            column: 40
          }
        }],
        line: 171
      },
      "17": {
        loc: {
          start: {
            line: 175,
            column: 2
          },
          end: {
            line: 189,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 176,
            column: 4
          },
          end: {
            line: 180,
            column: 12
          }
        }, {
          start: {
            line: 181,
            column: 4
          },
          end: {
            line: 183,
            column: 12
          }
        }, {
          start: {
            line: 184,
            column: 4
          },
          end: {
            line: 184,
            column: 18
          }
        }, {
          start: {
            line: 185,
            column: 4
          },
          end: {
            line: 187,
            column: 12
          }
        }, {
          start: {
            line: 188,
            column: 4
          },
          end: {
            line: 188,
            column: 12
          }
        }],
        line: 175
      },
      "18": {
        loc: {
          start: {
            line: 179,
            column: 18
          },
          end: {
            line: 179,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 179,
            column: 32
          },
          end: {
            line: 179,
            column: 58
          }
        }, {
          start: {
            line: 179,
            column: 61
          },
          end: {
            line: 179,
            column: 63
          }
        }],
        line: 179
      },
      "19": {
        loc: {
          start: {
            line: 204,
            column: 4
          },
          end: {
            line: 204,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 204,
            column: 37
          },
          end: {
            line: 204,
            column: 62
          }
        }, {
          start: {
            line: 204,
            column: 65
          },
          end: {
            line: 204,
            column: 93
          }
        }],
        line: 204
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0, 0, 0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0, 0, 0, 0],
      "18": [0, 0],
      "19": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9061f879f06d761431a15347495d4a2fae637557"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_25bxqxe5o4 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_25bxqxe5o4();
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(e, r) { return new BabelRegExp(e, void 0, r); }; var e = RegExp.prototype, r = new WeakMap(); function BabelRegExp(e, t, p) { var o = new RegExp(e, t); return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype); } function buildGroups(e, t) { var p = r.get(t); return Object.keys(p).reduce(function (r, t) { var o = p[t]; if ("number" == typeof o) r[t] = e[o];else { for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++; r[t] = e[o[i]]; } return r; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) { var t = e.exec.call(this, r); if (t) { t.groups = buildGroups(t, this); var p = t.indices; p && (p.groups = buildGroups(p, this)); } return t; }, BabelRegExp.prototype[Symbol.replace] = function (t, p) { if ("string" == typeof p) { var o = r.get(this); return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function (e, r) { var t = o[r]; return "$" + (Array.isArray(t) ? t.join("$") : t); })); } if ("function" == typeof p) { var i = this; return e[Symbol.replace].call(this, t, function () { var e = arguments; return "object" != _typeof(e[e.length - 1]) && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e); }); } return e[Symbol.replace].call(this, t, p); }, _wrapRegExp.apply(this, arguments); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }








































/* no-es-lib-transform - prevent mortar from breaking this path */


var mailcheckDefaultTopLevelDomains = (cov_25bxqxe5o4().s[0]++, ['com', 'net', 'org', 'info', 'edu']);
var stripDollarCommaPercentPunctuation = (cov_25bxqxe5o4().s[1]++, /\$|,|%/g);
var stripNonDigitPeriod = (cov_25bxqxe5o4().s[2]++, /[^\d.]/g);
var commaPositionsWithoutDecimal = (cov_25bxqxe5o4().s[3]++, /\d(?=(?:\d{3})+$)/g);
var commaPositionsWithDecimal = (cov_25bxqxe5o4().s[4]++, /\d(?=(?:\d{3})+(?:\.\d*)$)/g);
var mailcheckDefaultDomains = (cov_25bxqxe5o4().s[5]++, [
// Keep in sync with app/services/BriteVerifyService
'yahoo.com', 'google.com', 'hotmail.com', 'gmail.com', 'me.com', 'aol.com', 'mac.com', 'live.com', 'comcast.net', 'googlemail.com', 'msn.com', 'facebook.com', 'verizon.net', 'sbcglobal.net', 'att.net', 'mail.com', 'outlook.com', 'icloud.com', 'cox.net']);
var BLACKLISTED_TLDS = (cov_25bxqxe5o4().s[6]++, ['como', 'comp', 'con', 'met', 'ner', 'vom']);
cov_25bxqxe5o4().s[7]++;
var suggestEmail = function suggestEmail(email) {
  cov_25bxqxe5o4().f[0]++;
  cov_25bxqxe5o4().s[8]++;
  return new Promise(function (resolve) {
    cov_25bxqxe5o4().f[1]++;
    cov_25bxqxe5o4().s[9]++;
    mailcheck.run({
      domains: mailcheckDefaultDomains,
      email: email,
      empty: function empty() {
        cov_25bxqxe5o4().f[2]++;
        cov_25bxqxe5o4().s[10]++;
        return resolve('');
      },
      suggested: function suggested(suggestion) {
        cov_25bxqxe5o4().f[3]++;
        cov_25bxqxe5o4().s[11]++;
        if (includes(get(suggestion, 'domain'), '.')) {
          cov_25bxqxe5o4().b[0][0]++;
          cov_25bxqxe5o4().s[12]++;
          resolve(JSON.stringify(get(suggestion, 'full')).replace(/"/g, ''));
        } else {
          cov_25bxqxe5o4().b[0][1]++;
          cov_25bxqxe5o4().s[13]++;
          resolve('');
        }
      },
      topLevelDomains: mailcheckDefaultTopLevelDomains
    });
  });
};
cov_25bxqxe5o4().s[14]++;
var checkEmailValidity = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(value) {
    var valid, suggestion;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          cov_25bxqxe5o4().f[4]++;
          valid = (cov_25bxqxe5o4().s[15]++, (cov_25bxqxe5o4().b[1][0]++, !includes(BLACKLISTED_TLDS, last(value.split('.')))) && (cov_25bxqxe5o4().b[1][1]++, isEmail(value)));
          cov_25bxqxe5o4().s[16]++;
          _context.next = 5;
          return suggestEmail(value);
        case 5:
          suggestion = _context.sent;
          cov_25bxqxe5o4().s[17]++;
          return _context.abrupt("return", {
            valid: valid,
            suggestion: suggestion
          });
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function checkEmailValidity(_x) {
    return _ref.apply(this, arguments);
  };
}();
cov_25bxqxe5o4().s[18]++;
var checkTelValidity = function checkTelValidity(value) {
  cov_25bxqxe5o4().f[5]++;
  var phone = (cov_25bxqxe5o4().s[19]++, (0,parsePhoneNumber/* parsePhoneNumber */.S)(value, 'US'));
  cov_25bxqxe5o4().s[20]++;
  return (cov_25bxqxe5o4().b[2][0]++, phone) && (cov_25bxqxe5o4().b[2][1]++, phone.isValid());
};
cov_25bxqxe5o4().s[21]++;
var checkNumberValidity = function checkNumberValidity(value, minValue, maxValue) {
  cov_25bxqxe5o4().f[6]++;
  var valid = (cov_25bxqxe5o4().s[22]++, true);
  var parsedNum = (cov_25bxqxe5o4().s[23]++, value.replace(stripDollarCommaPercentPunctuation, ''));
  var numValue = (cov_25bxqxe5o4().s[24]++, parseFloat(parsedNum));
  cov_25bxqxe5o4().s[25]++;
  if ((cov_25bxqxe5o4().b[4][0]++, minValue) && (cov_25bxqxe5o4().b[4][1]++, minValue > numValue)) {
    cov_25bxqxe5o4().b[3][0]++;
    cov_25bxqxe5o4().s[26]++;
    valid = false;
  } else {
    cov_25bxqxe5o4().b[3][1]++;
  }
  cov_25bxqxe5o4().s[27]++;
  if ((cov_25bxqxe5o4().b[6][0]++, maxValue) && (cov_25bxqxe5o4().b[6][1]++, maxValue < numValue)) {
    cov_25bxqxe5o4().b[5][0]++;
    cov_25bxqxe5o4().s[28]++;
    valid = false;
  } else {
    cov_25bxqxe5o4().b[5][1]++;
  }
  cov_25bxqxe5o4().s[29]++;
  return valid;
};
cov_25bxqxe5o4().s[30]++;
var formatPercent = function formatPercent(value, decimalPlaces) {
  cov_25bxqxe5o4().f[7]++;
  var parsedNum = (cov_25bxqxe5o4().s[31]++, value.replace(stripDollarCommaPercentPunctuation, ''));
  var rounded = (cov_25bxqxe5o4().s[32]++, parseFloat(parsedNum).toFixed(decimalPlaces));

  // NOTE: Intl.Numberformat automatically replaces insignificant digits in the number string with zeroes
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
  var formattedNumber = (cov_25bxqxe5o4().s[33]++, new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: decimalPlaces
  }).format(isNaN(parseFloat(rounded)) ? (cov_25bxqxe5o4().b[7][0]++, 0) : (cov_25bxqxe5o4().b[7][1]++, parseFloat(rounded) / 100)));
  cov_25bxqxe5o4().s[34]++;
  return formattedNumber;
};
cov_25bxqxe5o4().s[35]++;
var formatNumber = function formatNumber(value, decimalPlaces) {
  cov_25bxqxe5o4().f[8]++;
  var parsedNum = (cov_25bxqxe5o4().s[36]++, value.replace(stripDollarCommaPercentPunctuation, ''));
  var rounded = (cov_25bxqxe5o4().s[37]++, parseFloat(parsedNum).toFixed(decimalPlaces));

  // NOTE: Intl.Numberformat automatically replaces insignificant digits in the number string with zeroes
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
  var formattedNumber = (cov_25bxqxe5o4().s[38]++, new Intl.NumberFormat('en-US', {
    minimumFractionDigits: decimalPlaces
  }).format(isNaN(parseFloat(rounded)) ? (cov_25bxqxe5o4().b[8][0]++, 0) : (cov_25bxqxe5o4().b[8][1]++, parseFloat(rounded))));
  cov_25bxqxe5o4().s[39]++;
  return formattedNumber;
};
cov_25bxqxe5o4().s[40]++;
var formatCurrencyValue = function formatCurrencyValue(value, roundToCents) {
  cov_25bxqxe5o4().f[9]++;
  // Removes '$' and ',' characters from the value string in order to parse value as a number
  var numValue = (cov_25bxqxe5o4().s[41]++, parseFloat(value.replace(stripDollarCommaPercentPunctuation, '')));
  cov_25bxqxe5o4().s[42]++;
  return (0,currencyHelpers/* centsToCurrencyString */.gn)(numValue * 100, roundToCents);
};
cov_25bxqxe5o4().s[43]++;
var formatValue = function formatValue(val, type, decimalPlaces) {
  cov_25bxqxe5o4().f[10]++;
  var newValue = (cov_25bxqxe5o4().s[44]++, val);
  cov_25bxqxe5o4().s[45]++;
  if ((cov_25bxqxe5o4().b[10][0]++, !newValue) || (cov_25bxqxe5o4().b[10][1]++, newValue.length === 0)) {
    cov_25bxqxe5o4().b[9][0]++;
    cov_25bxqxe5o4().s[46]++;
    return newValue;
  } else {
    cov_25bxqxe5o4().b[9][1]++;
  }
  cov_25bxqxe5o4().s[47]++;
  switch (type) {
    // format phone number input to the format of xxx-xxx-xxxx.
    case 'tel':
      cov_25bxqxe5o4().b[11][0]++;
      cov_25bxqxe5o4().s[48]++;
      // Prevents formatting when the changed value is just removing a parenthesis
      if (!((cov_25bxqxe5o4().b[13][0]++, newValue[0] === '(') && (cov_25bxqxe5o4().b[13][1]++, newValue.length <= 4))) {
        cov_25bxqxe5o4().b[12][0]++;
        /**
         * AsYouType format phone number into 3 ways:
         * number with + area code: +x xxx xxx xxxx.
         * number with area code: x (xxx) xxx-xxxx.
         * number without area code: (xxx) xxx-xxxx.
         */
        var regex = (cov_25bxqxe5o4().s[49]++, /*#__PURE__*/_wrapRegExp(/([\d]{3})\)? ([\d]{3})[- ]([\d]{4})/, {
          areaCode: 1,
          numberFirstThree: 2,
          numberLastFour: 3
        }));
        cov_25bxqxe5o4().s[50]++;
        newValue = new AsYouType/* AsYouType */.R('US').input(newValue);
        var match = (cov_25bxqxe5o4().s[51]++, newValue.match(regex));
        cov_25bxqxe5o4().s[52]++;
        if (match) {
          cov_25bxqxe5o4().b[14][0]++;
          var _ref2 = (cov_25bxqxe5o4().s[53]++, match.groups),
            areaCode = _ref2.areaCode,
            numberFirstThree = _ref2.numberFirstThree,
            numberLastFour = _ref2.numberLastFour;
          cov_25bxqxe5o4().s[54]++;
          newValue = "".concat(areaCode, "-").concat(numberFirstThree, "-").concat(numberLastFour);
        } else {
          cov_25bxqxe5o4().b[14][1]++;
        }
      } else {
        cov_25bxqxe5o4().b[12][1]++;
      }
      cov_25bxqxe5o4().s[55]++;
      break;
    case 'percent':
      cov_25bxqxe5o4().b[11][1]++;
      cov_25bxqxe5o4().s[56]++;
      newValue = formatPercent(newValue, decimalPlaces);
      cov_25bxqxe5o4().s[57]++;
      break;
    case 'number':
      cov_25bxqxe5o4().b[11][2]++;
      cov_25bxqxe5o4().s[58]++;
      newValue = formatNumber(newValue, decimalPlaces);
      cov_25bxqxe5o4().s[59]++;
      break;
    case 'currency':
      cov_25bxqxe5o4().b[11][3]++;
      cov_25bxqxe5o4().s[60]++;
      newValue = formatCurrencyValue(newValue, decimalPlaces > 0);
      cov_25bxqxe5o4().s[61]++;
      break;
    default:
      cov_25bxqxe5o4().b[11][4]++;
  }
  cov_25bxqxe5o4().s[62]++;
  return newValue;
};
cov_25bxqxe5o4().s[63]++;
var percentStringToDecimal = function percentStringToDecimal(value) {
  cov_25bxqxe5o4().f[11]++;
  var percentValue = (cov_25bxqxe5o4().s[64]++, Number(value.replace(stripDollarCommaPercentPunctuation, '')) / 100);
  cov_25bxqxe5o4().s[65]++;
  return percentValue.toString();
};
cov_25bxqxe5o4().s[66]++;
var unformatValue = function unformatValue(val, type) {
  cov_25bxqxe5o4().f[12]++;
  var newValue = (cov_25bxqxe5o4().s[67]++, val);
  cov_25bxqxe5o4().s[68]++;
  if ((cov_25bxqxe5o4().b[16][0]++, !newValue) || (cov_25bxqxe5o4().b[16][1]++, newValue.length === 0)) {
    cov_25bxqxe5o4().b[15][0]++;
    cov_25bxqxe5o4().s[69]++;
    return newValue;
  } else {
    cov_25bxqxe5o4().b[15][1]++;
  }
  cov_25bxqxe5o4().s[70]++;
  switch (type) {
    case 'tel':
      cov_25bxqxe5o4().b[17][0]++;
      // eslint-disable-next-line no-case-declarations
      var phoneNumber = (cov_25bxqxe5o4().s[71]++, (0,parsePhoneNumber/* parsePhoneNumber */.S)(newValue, 'US'));
      cov_25bxqxe5o4().s[72]++;
      newValue = phoneNumber ? (cov_25bxqxe5o4().b[18][0]++, phoneNumber.nationalNumber) : (cov_25bxqxe5o4().b[18][1]++, '');
      cov_25bxqxe5o4().s[73]++;
      break;
    case 'percent':
      cov_25bxqxe5o4().b[17][1]++;
      cov_25bxqxe5o4().s[74]++;
      newValue = percentStringToDecimal(newValue);
      cov_25bxqxe5o4().s[75]++;
      break;
    case 'number':
      cov_25bxqxe5o4().b[17][2]++;
    case 'currency':
      cov_25bxqxe5o4().b[17][3]++;
      cov_25bxqxe5o4().s[76]++;
      newValue = newValue.replace(stripDollarCommaPercentPunctuation, '');
      cov_25bxqxe5o4().s[77]++;
      break;
    default:
      cov_25bxqxe5o4().b[17][4]++;
  }
  cov_25bxqxe5o4().s[78]++;
  return newValue;
};

/*
  This function will strip any non digit or period characters then it will
  add commas to every third number after a decimal for added clarity while
  typing out a number in an input field.

  This does not format the value into the final output (i.e. formatValue) because
  we don't want to prematurely add decimals places to the input while typing.
*/
cov_25bxqxe5o4().s[79]++;
var sanitizeAndFormatNumberWithCommas = function sanitizeAndFormatNumberWithCommas(value) {
  cov_25bxqxe5o4().f[13]++;
  var sanitizedNum = (cov_25bxqxe5o4().s[80]++, value.replace(stripNonDigitPeriod, ''));
  var regex = (cov_25bxqxe5o4().s[81]++, sanitizedNum.indexOf('.') > -1 ? (cov_25bxqxe5o4().b[19][0]++, commaPositionsWithDecimal) : (cov_25bxqxe5o4().b[19][1]++, commaPositionsWithoutDecimal));
  cov_25bxqxe5o4().s[82]++;
  return sanitizedNum.replace(regex, '$&,');
};
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Flex/Flex.mjs
var Flex = __webpack_require__(93298);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Text/Text.mjs
var Text = __webpack_require__(4796);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Label/Label.mjs
var Label = __webpack_require__(2775);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks/es/core/Input/InputBase.mjs
var InputBase = __webpack_require__(32960);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks/es/core/Input/Input.mjs
function Input_typeof(o) { "@babel/helpers - typeof"; return Input_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Input_typeof(o); }




























var _excluded = ["fontSize", "label", "subtitle", "errorMessage", "invalid", "decimalPlaces", "delay", "value", "onChange", "type", "unboundedWidth", "orientation", "min", "max", "customEmailValidityCheck", "labelStyles", "disabled", "helperText", "maxLength", "required", "placeholder", "analyticsName", "defaultValue"],
  _excluded2 = ["suggestion", "useSuggestion"];
function cov_ndg0d3lom() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Input/Input.tsx";
  var hash = "826aea9cef06da0da1c118251a947db240c09c53";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Input/Input.tsx",
    statementMap: {
      "0": {
        start: {
          line: 21,
          column: 30
        },
        end: {
          line: 21,
          column: 59
        }
      },
      "1": {
        start: {
          line: 360,
          column: 43
        },
        end: {
          line: 633,
          column: 1
        }
      },
      "2": {
        start: {
          line: 387,
          column: 4
        },
        end: {
          line: 387,
          column: 80
        }
      },
      "3": {
        start: {
          line: 388,
          column: 35
        },
        end: {
          line: 390,
          column: 3
        }
      },
      "4": {
        start: {
          line: 394,
          column: 2
        },
        end: {
          line: 404,
          column: 21
        }
      },
      "5": {
        start: {
          line: 395,
          column: 4
        },
        end: {
          line: 397,
          column: 5
        }
      },
      "6": {
        start: {
          line: 396,
          column: 6
        },
        end: {
          line: 396,
          column: 13
        }
      },
      "7": {
        start: {
          line: 399,
          column: 4
        },
        end: {
          line: 402,
          column: 5
        }
      },
      "8": {
        start: {
          line: 400,
          column: 36
        },
        end: {
          line: 400,
          column: 82
        }
      },
      "9": {
        start: {
          line: 401,
          column: 6
        },
        end: {
          line: 401,
          column: 43
        }
      },
      "10": {
        start: {
          line: 406,
          column: 46
        },
        end: {
          line: 406,
          column: 70
        }
      },
      "11": {
        start: {
          line: 407,
          column: 33
        },
        end: {
          line: 407,
          column: 64
        }
      },
      "12": {
        start: {
          line: 408,
          column: 38
        },
        end: {
          line: 408,
          column: 62
        }
      },
      "13": {
        start: {
          line: 409,
          column: 32
        },
        end: {
          line: 409,
          column: 68
        }
      },
      "14": {
        start: {
          line: 410,
          column: 44
        },
        end: {
          line: 410,
          column: 74
        }
      },
      "15": {
        start: {
          line: 411,
          column: 28
        },
        end: {
          line: 422,
          column: 3
        }
      },
      "16": {
        start: {
          line: 413,
          column: 6
        },
        end: {
          line: 419,
          column: 7
        }
      },
      "17": {
        start: {
          line: 414,
          column: 33
        },
        end: {
          line: 414,
          column: 57
        }
      },
      "18": {
        start: {
          line: 415,
          column: 38
        },
        end: {
          line: 415,
          column: 62
        }
      },
      "19": {
        start: {
          line: 416,
          column: 8
        },
        end: {
          line: 416,
          column: 27
        }
      },
      "20": {
        start: {
          line: 417,
          column: 8
        },
        end: {
          line: 417,
          column: 34
        }
      },
      "21": {
        start: {
          line: 418,
          column: 8
        },
        end: {
          line: 418,
          column: 45
        }
      },
      "22": {
        start: {
          line: 423,
          column: 19
        },
        end: {
          line: 423,
          column: 51
        }
      },
      "23": {
        start: {
          line: 424,
          column: 21
        },
        end: {
          line: 424,
          column: 93
        }
      },
      "24": {
        start: {
          line: 426,
          column: 23
        },
        end: {
          line: 426,
          column: 94
        }
      },
      "25": {
        start: {
          line: 427,
          column: 34
        },
        end: {
          line: 427,
          column: 62
        }
      },
      "26": {
        start: {
          line: 429,
          column: 24
        },
        end: {
          line: 433,
          column: 3
        }
      },
      "27": {
        start: {
          line: 430,
          column: 4
        },
        end: {
          line: 430,
          column: 30
        }
      },
      "28": {
        start: {
          line: 431,
          column: 4
        },
        end: {
          line: 431,
          column: 45
        }
      },
      "29": {
        start: {
          line: 432,
          column: 4
        },
        end: {
          line: 432,
          column: 29
        }
      },
      "30": {
        start: {
          line: 435,
          column: 24
        },
        end: {
          line: 461,
          column: 3
        }
      },
      "31": {
        start: {
          line: 438,
          column: 16
        },
        end: {
          line: 438,
          column: 20
        }
      },
      "32": {
        start: {
          line: 439,
          column: 21
        },
        end: {
          line: 439,
          column: 23
        }
      },
      "33": {
        start: {
          line: 441,
          column: 4
        },
        end: {
          line: 459,
          column: 5
        }
      },
      "34": {
        start: {
          line: 442,
          column: 6
        },
        end: {
          line: 442,
          column: 24
        }
      },
      "35": {
        start: {
          line: 444,
          column: 6
        },
        end: {
          line: 458,
          column: 7
        }
      },
      "36": {
        start: {
          line: 447,
          column: 38
        },
        end: {
          line: 447,
          column: 64
        }
      },
      "37": {
        start: {
          line: 448,
          column: 10
        },
        end: {
          line: 448,
          column: 44
        }
      },
      "38": {
        start: {
          line: 449,
          column: 10
        },
        end: {
          line: 449,
          column: 54
        }
      },
      "39": {
        start: {
          line: 450,
          column: 10
        },
        end: {
          line: 450,
          column: 16
        }
      },
      "40": {
        start: {
          line: 452,
          column: 10
        },
        end: {
          line: 452,
          column: 45
        }
      },
      "41": {
        start: {
          line: 453,
          column: 10
        },
        end: {
          line: 453,
          column: 16
        }
      },
      "42": {
        start: {
          line: 455,
          column: 10
        },
        end: {
          line: 455,
          column: 58
        }
      },
      "43": {
        start: {
          line: 456,
          column: 10
        },
        end: {
          line: 456,
          column: 16
        }
      },
      "44": {
        start: {
          line: 460,
          column: 4
        },
        end: {
          line: 460,
          column: 33
        }
      },
      "45": {
        start: {
          line: 464,
          column: 23
        },
        end: {
          line: 477,
          column: 3
        }
      },
      "46": {
        start: {
          line: 465,
          column: 4
        },
        end: {
          line: 476,
          column: 5
        }
      },
      "47": {
        start: {
          line: 467,
          column: 8
        },
        end: {
          line: 467,
          column: 23
        }
      },
      "48": {
        start: {
          line: 469,
          column: 8
        },
        end: {
          line: 469,
          column: 21
        }
      },
      "49": {
        start: {
          line: 473,
          column: 8
        },
        end: {
          line: 473,
          column: 57
        }
      },
      "50": {
        start: {
          line: 475,
          column: 8
        },
        end: {
          line: 475,
          column: 22
        }
      },
      "51": {
        start: {
          line: 479,
          column: 18
        },
        end: {
          line: 502,
          column: 3
        }
      },
      "52": {
        start: {
          line: 480,
          column: 4
        },
        end: {
          line: 501,
          column: 5
        }
      },
      "53": {
        start: {
          line: 482,
          column: 8
        },
        end: {
          line: 482,
          column: 26
        }
      },
      "54": {
        start: {
          line: 484,
          column: 8
        },
        end: {
          line: 484,
          column: 23
        }
      },
      "55": {
        start: {
          line: 486,
          column: 8
        },
        end: {
          line: 486,
          column: 21
        }
      },
      "56": {
        start: {
          line: 490,
          column: 8
        },
        end: {
          line: 490,
          column: 22
        }
      },
      "57": {
        start: {
          line: 494,
          column: 8
        },
        end: {
          line: 494,
          column: 22
        }
      },
      "58": {
        start: {
          line: 498,
          column: 8
        },
        end: {
          line: 498,
          column: 22
        }
      },
      "59": {
        start: {
          line: 500,
          column: 8
        },
        end: {
          line: 500,
          column: 22
        }
      },
      "60": {
        start: {
          line: 504,
          column: 25
        },
        end: {
          line: 517,
          column: 3
        }
      },
      "61": {
        start: {
          line: 505,
          column: 4
        },
        end: {
          line: 516,
          column: 5
        }
      },
      "62": {
        start: {
          line: 507,
          column: 8
        },
        end: {
          line: 507,
          column: 33
        }
      },
      "63": {
        start: {
          line: 509,
          column: 8
        },
        end: {
          line: 509,
          column: 32
        }
      },
      "64": {
        start: {
          line: 511,
          column: 8
        },
        end: {
          line: 511,
          column: 23
        }
      },
      "65": {
        start: {
          line: 513,
          column: 8
        },
        end: {
          line: 513,
          column: 23
        }
      },
      "66": {
        start: {
          line: 515,
          column: 8
        },
        end: {
          line: 515,
          column: 18
        }
      },
      "67": {
        start: {
          line: 519,
          column: 35
        },
        end: {
          line: 528,
          column: 3
        }
      },
      "68": {
        start: {
          line: 520,
          column: 4
        },
        end: {
          line: 527,
          column: 5
        }
      },
      "69": {
        start: {
          line: 522,
          column: 8
        },
        end: {
          line: 522,
          column: 23
        }
      },
      "70": {
        start: {
          line: 524,
          column: 8
        },
        end: {
          line: 524,
          column: 21
        }
      },
      "71": {
        start: {
          line: 526,
          column: 8
        },
        end: {
          line: 526,
          column: 25
        }
      },
      "72": {
        start: {
          line: 534,
          column: 2
        },
        end: {
          line: 538,
          column: 23
        }
      },
      "73": {
        start: {
          line: 535,
          column: 4
        },
        end: {
          line: 537,
          column: 5
        }
      },
      "74": {
        start: {
          line: 536,
          column: 6
        },
        end: {
          line: 536,
          column: 73
        }
      },
      "75": {
        start: {
          line: 540,
          column: 31
        },
        end: {
          line: 546,
          column: 3
        }
      },
      "76": {
        start: {
          line: 541,
          column: 22
        },
        end: {
          line: 541,
          column: 62
        }
      },
      "77": {
        start: {
          line: 542,
          column: 27
        },
        end: {
          line: 542,
          column: 58
        }
      },
      "78": {
        start: {
          line: 543,
          column: 30
        },
        end: {
          line: 543,
          column: 61
        }
      },
      "79": {
        start: {
          line: 544,
          column: 4
        },
        end: {
          line: 544,
          column: 69
        }
      },
      "80": {
        start: {
          line: 545,
          column: 4
        },
        end: {
          line: 545,
          column: 29
        }
      },
      "81": {
        start: {
          line: 548,
          column: 23
        },
        end: {
          line: 561,
          column: 3
        }
      },
      "82": {
        start: {
          line: 549,
          column: 4
        },
        end: {
          line: 549,
          column: 23
        }
      },
      "83": {
        start: {
          line: 550,
          column: 4
        },
        end: {
          line: 550,
          column: 27
        }
      },
      "84": {
        start: {
          line: 551,
          column: 4
        },
        end: {
          line: 551,
          column: 48
        }
      },
      "85": {
        start: {
          line: 552,
          column: 4
        },
        end: {
          line: 552,
          column: 32
        }
      },
      "86": {
        start: {
          line: 553,
          column: 4
        },
        end: {
          line: 560,
          column: 5
        }
      },
      "87": {
        start: {
          line: 556,
          column: 8
        },
        end: {
          line: 556,
          column: 84
        }
      },
      "88": {
        start: {
          line: 557,
          column: 8
        },
        end: {
          line: 557,
          column: 14
        }
      },
      "89": {
        start: {
          line: 559,
          column: 8
        },
        end: {
          line: 559,
          column: 45
        }
      },
      "90": {
        start: {
          line: 563,
          column: 21
        },
        end: {
          line: 566,
          column: 3
        }
      },
      "91": {
        start: {
          line: 564,
          column: 4
        },
        end: {
          line: 564,
          column: 27
        }
      },
      "92": {
        start: {
          line: 565,
          column: 4
        },
        end: {
          line: 565,
          column: 61
        }
      },
      "93": {
        start: {
          line: 569,
          column: 25
        },
        end: {
          line: 569,
          column: 83
        }
      },
      "94": {
        start: {
          line: 571,
          column: 2
        },
        end: {
          line: 632,
          column: 4
        }
      },
      "95": {
        start: {
          line: 635,
          column: 38
        },
        end: {
          line: 637,
          column: 1
        }
      },
      "96": {
        start: {
          line: 636,
          column: 2
        },
        end: {
          line: 636,
          column: 86
        }
      },
      "97": {
        start: {
          line: 639,
          column: 38
        },
        end: {
          line: 639,
          column: 96
        }
      },
      "98": {
        start: {
          line: 639,
          column: 49
        },
        end: {
          line: 639,
          column: 96
        }
      },
      "99": {
        start: {
          line: 646,
          column: 4
        },
        end: {
          line: 659,
          column: 1
        }
      },
      "100": {
        start: {
          line: 648,
          column: 2
        },
        end: {
          line: 658,
          column: 9
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 360,
            column: 43
          },
          end: {
            line: 360,
            column: 44
          }
        },
        loc: {
          start: {
            line: 385,
            column: 6
          },
          end: {
            line: 633,
            column: 1
          }
        },
        line: 385
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 394,
            column: 12
          },
          end: {
            line: 394,
            column: 13
          }
        },
        loc: {
          start: {
            line: 394,
            column: 18
          },
          end: {
            line: 404,
            column: 3
          }
        },
        line: 394
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 412,
            column: 4
          },
          end: {
            line: 412,
            column: 5
          }
        },
        loc: {
          start: {
            line: 412,
            column: 69
          },
          end: {
            line: 420,
            column: 5
          }
        },
        line: 412
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 429,
            column: 24
          },
          end: {
            line: 429,
            column: 25
          }
        },
        loc: {
          start: {
            line: 429,
            column: 30
          },
          end: {
            line: 433,
            column: 3
          }
        },
        line: 429
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 435,
            column: 24
          },
          end: {
            line: 435,
            column: 25
          }
        },
        loc: {
          start: {
            line: 437,
            column: 56
          },
          end: {
            line: 461,
            column: 3
          }
        },
        line: 437
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 464,
            column: 23
          },
          end: {
            line: 464,
            column: 24
          }
        },
        loc: {
          start: {
            line: 464,
            column: 29
          },
          end: {
            line: 477,
            column: 3
          }
        },
        line: 464
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 479,
            column: 18
          },
          end: {
            line: 479,
            column: 19
          }
        },
        loc: {
          start: {
            line: 479,
            column: 24
          },
          end: {
            line: 502,
            column: 3
          }
        },
        line: 479
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 504,
            column: 25
          },
          end: {
            line: 504,
            column: 26
          }
        },
        loc: {
          start: {
            line: 504,
            column: 31
          },
          end: {
            line: 517,
            column: 3
          }
        },
        line: 504
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 519,
            column: 35
          },
          end: {
            line: 519,
            column: 36
          }
        },
        loc: {
          start: {
            line: 519,
            column: 87
          },
          end: {
            line: 528,
            column: 3
          }
        },
        line: 519
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 534,
            column: 12
          },
          end: {
            line: 534,
            column: 13
          }
        },
        loc: {
          start: {
            line: 534,
            column: 18
          },
          end: {
            line: 538,
            column: 3
          }
        },
        line: 534
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 540,
            column: 31
          },
          end: {
            line: 540,
            column: 32
          }
        },
        loc: {
          start: {
            line: 540,
            column: 74
          },
          end: {
            line: 546,
            column: 3
          }
        },
        line: 540
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 548,
            column: 23
          },
          end: {
            line: 548,
            column: 24
          }
        },
        loc: {
          start: {
            line: 548,
            column: 67
          },
          end: {
            line: 561,
            column: 3
          }
        },
        line: 548
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 563,
            column: 21
          },
          end: {
            line: 563,
            column: 22
          }
        },
        loc: {
          start: {
            line: 563,
            column: 27
          },
          end: {
            line: 566,
            column: 3
          }
        },
        line: 563
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 635,
            column: 38
          },
          end: {
            line: 635,
            column: 39
          }
        },
        loc: {
          start: {
            line: 636,
            column: 2
          },
          end: {
            line: 636,
            column: 86
          }
        },
        line: 636
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 639,
            column: 38
          },
          end: {
            line: 639,
            column: 39
          }
        },
        loc: {
          start: {
            line: 639,
            column: 49
          },
          end: {
            line: 639,
            column: 96
          }
        },
        line: 639
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 646,
            column: 4
          },
          end: {
            line: 646,
            column: 5
          }
        },
        loc: {
          start: {
            line: 648,
            column: 2
          },
          end: {
            line: 658,
            column: 9
          }
        },
        line: 648
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 361,
            column: 2
          },
          end: {
            line: 361,
            column: 17
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 361,
            column: 13
          },
          end: {
            line: 361,
            column: 17
          }
        }],
        line: 361
      },
      "1": {
        loc: {
          start: {
            line: 367,
            column: 2
          },
          end: {
            line: 367,
            column: 13
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 367,
            column: 10
          },
          end: {
            line: 367,
            column: 13
          }
        }],
        line: 367
      },
      "2": {
        loc: {
          start: {
            line: 370,
            column: 2
          },
          end: {
            line: 370,
            column: 15
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 370,
            column: 9
          },
          end: {
            line: 370,
            column: 15
          }
        }],
        line: 370
      },
      "3": {
        loc: {
          start: {
            line: 371,
            column: 2
          },
          end: {
            line: 371,
            column: 24
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 371,
            column: 19
          },
          end: {
            line: 371,
            column: 24
          }
        }],
        line: 371
      },
      "4": {
        loc: {
          start: {
            line: 372,
            column: 2
          },
          end: {
            line: 372,
            column: 26
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 372,
            column: 16
          },
          end: {
            line: 372,
            column: 26
          }
        }],
        line: 372
      },
      "5": {
        loc: {
          start: {
            line: 387,
            column: 4
          },
          end: {
            line: 387,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 387,
            column: 56
          },
          end: {
            line: 387,
            column: 76
          }
        }, {
          start: {
            line: 387,
            column: 79
          },
          end: {
            line: 387,
            column: 80
          }
        }],
        line: 387
      },
      "6": {
        loc: {
          start: {
            line: 387,
            column: 4
          },
          end: {
            line: 387,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 387,
            column: 4
          },
          end: {
            line: 387,
            column: 24
          }
        }, {
          start: {
            line: 387,
            column: 28
          },
          end: {
            line: 387,
            column: 53
          }
        }],
        line: 387
      },
      "7": {
        loc: {
          start: {
            line: 389,
            column: 4
          },
          end: {
            line: 389,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 389,
            column: 12
          },
          end: {
            line: 389,
            column: 51
          }
        }, {
          start: {
            line: 389,
            column: 54
          },
          end: {
            line: 389,
            column: 56
          }
        }],
        line: 389
      },
      "8": {
        loc: {
          start: {
            line: 395,
            column: 4
          },
          end: {
            line: 397,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 395,
            column: 4
          },
          end: {
            line: 397,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 395
      },
      "9": {
        loc: {
          start: {
            line: 399,
            column: 4
          },
          end: {
            line: 402,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 399,
            column: 4
          },
          end: {
            line: 402,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 399
      },
      "10": {
        loc: {
          start: {
            line: 413,
            column: 6
          },
          end: {
            line: 419,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 413,
            column: 6
          },
          end: {
            line: 419,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 413
      },
      "11": {
        loc: {
          start: {
            line: 424,
            column: 21
          },
          end: {
            line: 424,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 424,
            column: 48
          },
          end: {
            line: 424,
            column: 72
          }
        }, {
          start: {
            line: 424,
            column: 75
          },
          end: {
            line: 424,
            column: 93
          }
        }],
        line: 424
      },
      "12": {
        loc: {
          start: {
            line: 426,
            column: 23
          },
          end: {
            line: 426,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 426,
            column: 54
          },
          end: {
            line: 426,
            column: 75
          }
        }, {
          start: {
            line: 426,
            column: 78
          },
          end: {
            line: 426,
            column: 94
          }
        }],
        line: 426
      },
      "13": {
        loc: {
          start: {
            line: 426,
            column: 23
          },
          end: {
            line: 426,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 426,
            column: 23
          },
          end: {
            line: 426,
            column: 31
          }
        }, {
          start: {
            line: 426,
            column: 35
          },
          end: {
            line: 426,
            column: 51
          }
        }],
        line: 426
      },
      "14": {
        loc: {
          start: {
            line: 441,
            column: 4
          },
          end: {
            line: 459,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 441,
            column: 4
          },
          end: {
            line: 459,
            column: 5
          }
        }, {
          start: {
            line: 443,
            column: 11
          },
          end: {
            line: 459,
            column: 5
          }
        }],
        line: 441
      },
      "15": {
        loc: {
          start: {
            line: 444,
            column: 6
          },
          end: {
            line: 458,
            column: 7
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 445,
            column: 8
          },
          end: {
            line: 450,
            column: 16
          }
        }, {
          start: {
            line: 451,
            column: 8
          },
          end: {
            line: 453,
            column: 16
          }
        }, {
          start: {
            line: 454,
            column: 8
          },
          end: {
            line: 456,
            column: 16
          }
        }, {
          start: {
            line: 457,
            column: 8
          },
          end: {
            line: 457,
            column: 16
          }
        }],
        line: 444
      },
      "16": {
        loc: {
          start: {
            line: 465,
            column: 4
          },
          end: {
            line: 476,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 466,
            column: 6
          },
          end: {
            line: 467,
            column: 23
          }
        }, {
          start: {
            line: 468,
            column: 6
          },
          end: {
            line: 469,
            column: 21
          }
        }, {
          start: {
            line: 470,
            column: 6
          },
          end: {
            line: 470,
            column: 21
          }
        }, {
          start: {
            line: 471,
            column: 6
          },
          end: {
            line: 471,
            column: 20
          }
        }, {
          start: {
            line: 472,
            column: 6
          },
          end: {
            line: 473,
            column: 57
          }
        }, {
          start: {
            line: 474,
            column: 6
          },
          end: {
            line: 475,
            column: 22
          }
        }],
        line: 465
      },
      "17": {
        loc: {
          start: {
            line: 473,
            column: 15
          },
          end: {
            line: 473,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 473,
            column: 35
          },
          end: {
            line: 473,
            column: 44
          }
        }, {
          start: {
            line: 473,
            column: 47
          },
          end: {
            line: 473,
            column: 56
          }
        }],
        line: 473
      },
      "18": {
        loc: {
          start: {
            line: 480,
            column: 4
          },
          end: {
            line: 501,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 481,
            column: 6
          },
          end: {
            line: 482,
            column: 26
          }
        }, {
          start: {
            line: 483,
            column: 6
          },
          end: {
            line: 484,
            column: 23
          }
        }, {
          start: {
            line: 485,
            column: 6
          },
          end: {
            line: 486,
            column: 21
          }
        }, {
          start: {
            line: 487,
            column: 6
          },
          end: {
            line: 490,
            column: 22
          }
        }, {
          start: {
            line: 491,
            column: 6
          },
          end: {
            line: 494,
            column: 22
          }
        }, {
          start: {
            line: 495,
            column: 6
          },
          end: {
            line: 498,
            column: 22
          }
        }, {
          start: {
            line: 499,
            column: 6
          },
          end: {
            line: 500,
            column: 22
          }
        }],
        line: 480
      },
      "19": {
        loc: {
          start: {
            line: 505,
            column: 4
          },
          end: {
            line: 516,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 506,
            column: 6
          },
          end: {
            line: 507,
            column: 33
          }
        }, {
          start: {
            line: 508,
            column: 6
          },
          end: {
            line: 509,
            column: 32
          }
        }, {
          start: {
            line: 510,
            column: 6
          },
          end: {
            line: 511,
            column: 23
          }
        }, {
          start: {
            line: 512,
            column: 6
          },
          end: {
            line: 513,
            column: 23
          }
        }, {
          start: {
            line: 514,
            column: 6
          },
          end: {
            line: 515,
            column: 18
          }
        }],
        line: 505
      },
      "20": {
        loc: {
          start: {
            line: 520,
            column: 4
          },
          end: {
            line: 527,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 521,
            column: 6
          },
          end: {
            line: 522,
            column: 23
          }
        }, {
          start: {
            line: 523,
            column: 6
          },
          end: {
            line: 524,
            column: 21
          }
        }, {
          start: {
            line: 525,
            column: 6
          },
          end: {
            line: 526,
            column: 25
          }
        }],
        line: 520
      },
      "21": {
        loc: {
          start: {
            line: 535,
            column: 4
          },
          end: {
            line: 537,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 535,
            column: 4
          },
          end: {
            line: 537,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 535
      },
      "22": {
        loc: {
          start: {
            line: 535,
            column: 8
          },
          end: {
            line: 535,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 535,
            column: 8
          },
          end: {
            line: 535,
            column: 24
          }
        }, {
          start: {
            line: 535,
            column: 28
          },
          end: {
            line: 535,
            column: 56
          }
        }],
        line: 535
      },
      "23": {
        loc: {
          start: {
            line: 544,
            column: 22
          },
          end: {
            line: 544,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 544,
            column: 46
          },
          end: {
            line: 544,
            column: 63
          }
        }, {
          start: {
            line: 544,
            column: 66
          },
          end: {
            line: 544,
            column: 67
          }
        }],
        line: 544
      },
      "24": {
        loc: {
          start: {
            line: 553,
            column: 4
          },
          end: {
            line: 560,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 554,
            column: 6
          },
          end: {
            line: 554,
            column: 20
          }
        }, {
          start: {
            line: 555,
            column: 6
          },
          end: {
            line: 557,
            column: 14
          }
        }, {
          start: {
            line: 558,
            column: 6
          },
          end: {
            line: 559,
            column: 45
          }
        }],
        line: 553
      },
      "25": {
        loc: {
          start: {
            line: 569,
            column: 25
          },
          end: {
            line: 569,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 569,
            column: 26
          },
          end: {
            line: 569,
            column: 34
          }
        }, {
          start: {
            line: 569,
            column: 38
          },
          end: {
            line: 569,
            column: 54
          }
        }, {
          start: {
            line: 569,
            column: 58
          },
          end: {
            line: 569,
            column: 71
          }
        }, {
          start: {
            line: 569,
            column: 76
          },
          end: {
            line: 569,
            column: 83
          }
        }],
        line: 569
      },
      "26": {
        loc: {
          start: {
            line: 574,
            column: 21
          },
          end: {
            line: 574,
            column: 63
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 574,
            column: 47
          },
          end: {
            line: 574,
            column: 52
          }
        }, {
          start: {
            line: 574,
            column: 55
          },
          end: {
            line: 574,
            column: 63
          }
        }],
        line: 574
      },
      "27": {
        loc: {
          start: {
            line: 575,
            column: 18
          },
          end: {
            line: 575,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 575,
            column: 44
          },
          end: {
            line: 575,
            column: 52
          }
        }, {
          start: {
            line: 575,
            column: 55
          },
          end: {
            line: 575,
            column: 57
          }
        }],
        line: 575
      },
      "28": {
        loc: {
          start: {
            line: 576,
            column: 28
          },
          end: {
            line: 576,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 576,
            column: 45
          },
          end: {
            line: 576,
            column: 51
          }
        }, {
          start: {
            line: 576,
            column: 54
          },
          end: {
            line: 576,
            column: 61
          }
        }],
        line: 576
      },
      "29": {
        loc: {
          start: {
            line: 578,
            column: 7
          },
          end: {
            line: 603,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 578,
            column: 8
          },
          end: {
            line: 578,
            column: 13
          }
        }, {
          start: {
            line: 578,
            column: 17
          },
          end: {
            line: 578,
            column: 25
          }
        }, {
          start: {
            line: 579,
            column: 8
          },
          end: {
            line: 602,
            column: 15
          }
        }],
        line: 578
      },
      "30": {
        loc: {
          start: {
            line: 583,
            column: 14
          },
          end: {
            line: 583,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 583,
            column: 40
          },
          end: {
            line: 583,
            column: 46
          }
        }, {
          start: {
            line: 583,
            column: 49
          },
          end: {
            line: 583,
            column: 51
          }
        }],
        line: 583
      },
      "31": {
        loc: {
          start: {
            line: 584,
            column: 14
          },
          end: {
            line: 584,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 584,
            column: 40
          },
          end: {
            line: 584,
            column: 42
          }
        }, {
          start: {
            line: 584,
            column: 45
          },
          end: {
            line: 584,
            column: 51
          }
        }],
        line: 584
      },
      "32": {
        loc: {
          start: {
            line: 586,
            column: 11
          },
          end: {
            line: 596,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 586,
            column: 11
          },
          end: {
            line: 586,
            column: 16
          }
        }, {
          start: {
            line: 587,
            column: 12
          },
          end: {
            line: 595,
            column: 20
          }
        }],
        line: 586
      },
      "33": {
        loc: {
          start: {
            line: 591,
            column: 21
          },
          end: {
            line: 591,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 591,
            column: 32
          },
          end: {
            line: 591,
            column: 44
          }
        }, {
          start: {
            line: 591,
            column: 47
          },
          end: {
            line: 591,
            column: 56
          }
        }],
        line: 591
      },
      "34": {
        loc: {
          start: {
            line: 597,
            column: 11
          },
          end: {
            line: 601,
            column: 11
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 597,
            column: 11
          },
          end: {
            line: 597,
            column: 19
          }
        }, {
          start: {
            line: 598,
            column: 12
          },
          end: {
            line: 600,
            column: 19
          }
        }],
        line: 597
      },
      "35": {
        loc: {
          start: {
            line: 599,
            column: 31
          },
          end: {
            line: 599,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 599,
            column: 42
          },
          end: {
            line: 599,
            column: 54
          }
        }, {
          start: {
            line: 599,
            column: 57
          },
          end: {
            line: 599,
            column: 70
          }
        }],
        line: 599
      },
      "36": {
        loc: {
          start: {
            line: 618,
            column: 21
          },
          end: {
            line: 618,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 618,
            column: 38
          },
          end: {
            line: 618,
            column: 40
          }
        }, {
          start: {
            line: 618,
            column: 43
          },
          end: {
            line: 618,
            column: 52
          }
        }],
        line: 618
      },
      "37": {
        loc: {
          start: {
            line: 619,
            column: 23
          },
          end: {
            line: 619,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 619,
            column: 23
          },
          end: {
            line: 619,
            column: 34
          }
        }, {
          start: {
            line: 619,
            column: 38
          },
          end: {
            line: 619,
            column: 54
          }
        }],
        line: 619
      },
      "38": {
        loc: {
          start: {
            line: 625,
            column: 9
          },
          end: {
            line: 625,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 625,
            column: 9
          },
          end: {
            line: 625,
            column: 21
          }
        }, {
          start: {
            line: 625,
            column: 25
          },
          end: {
            line: 625,
            column: 39
          }
        }, {
          start: {
            line: 625,
            column: 43
          },
          end: {
            line: 625,
            column: 81
          }
        }],
        line: 625
      },
      "39": {
        loc: {
          start: {
            line: 626,
            column: 9
          },
          end: {
            line: 626,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 626,
            column: 9
          },
          end: {
            line: 626,
            column: 19
          }
        }, {
          start: {
            line: 626,
            column: 23
          },
          end: {
            line: 626,
            column: 56
          }
        }],
        line: 626
      },
      "40": {
        loc: {
          start: {
            line: 627,
            column: 9
          },
          end: {
            line: 629,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 627,
            column: 9
          },
          end: {
            line: 627,
            column: 19
          }
        }, {
          start: {
            line: 628,
            column: 10
          },
          end: {
            line: 628,
            column: 98
          }
        }],
        line: 627
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0, 0, 0],
      "16": [0, 0, 0, 0, 0, 0],
      "17": [0, 0],
      "18": [0, 0, 0, 0, 0, 0, 0],
      "19": [0, 0, 0, 0, 0],
      "20": [0, 0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0, 0],
      "25": [0, 0, 0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0, 0],
      "39": [0, 0],
      "40": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "826aea9cef06da0da1c118251a947db240c09c53"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_ndg0d3lom = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_ndg0d3lom();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function Input_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ Input_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == Input_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(Input_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function Input_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function Input_asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { Input_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { Input_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var ASSERT_NOT_NULL_ERROR = (cov_ndg0d3lom().s[0]++, 'This field cannot be empty.');
/**
 * Input component is a component that is used to get user input in a text
 * field.
 *
 * The Input component is a basic text input component. It directly maps to an
 * input element.
 *
 * ###
 *
 * About Input Props
 *
 * Input extends the `<input>` form element documented
 * [here](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input)
 *
 * Input type variations
 * -----------------------------------------------------------------------------------------------
 *
 * "text"
 *
 * "password"
 *
 * "newPassword"
 *
 * "numberPad"
 *
 * "decimalPad"
 *
 * "numeric"
 *
 * "email"
 *
 * "phone"
 *
 * Accessibility
 *
 *
 * -----------------
 *
 * ###
 *
 * Labels for Input component
 *
 * Each form field must have a visible label that is properly associated with
 * it. Do not use a placeholder instead of a label because a placeholder
 * disappears as soon as a user enters content in the field.
 *
 * The best approach is to pass in the `label` prop when you use the bricks
 * `Input` component:
 *
 * ####
 *
 * ✅ Pass
 *
 * `<Input id="example" label="First Name" placeholder="Alice Smith" ... />`
 *
 * This renders the input below:
 *
 * ####
 *
 * 🛑 Fail
 *
 * `<Input id="example" placeholder="First Name" ... />` This renders an input
 * without an associated label:
 *
 * If for some reason, you can not pass in the `label` prop for the input
 * component you may also use a different element containing visible text as
 * long as you associate it to the `<input>` element using the `aria-labelledby`
 * attribute:
 *
 * ####
 *
 * ✅ Pass
 *
 * `<Box> <Image src="image.jpg" id="fname" alt="First Name"> </Box> <Box>
 * <Input id="example" aria-labelledby="fname" /> </Box>`
 *
 * We strongly encourage that you use the `label` prop built in the input
 * component for design consistency. But if some reason you need to use a unqiue
 * design for your `label` please reach out to CPLAT.
 *
 * Finally, as a last resort, if it isn’t possible to include visible text as a
 * label, include the aria-label prop:
 *
 * ####
 *
 * Needs Improvement
 *
 * `<Input id="example" aria-label="First Name" />`
 *
 * ####
 *
 * Further reading
 *
 * [A360 - Form Field Not Labeled](https://hub.accessible360.com/kb/articles/48)
 *
 * ###
 *
 * Autocomplete attributes
 *
 * Any text-based form field that accepts ubiquitous user data requires the
 * inclusion of the autocomplete attribute. This attribute provides the name of
 * the type of data expected in a programmatic fashion. This allows user agents
 * to offer suggestions and provide the ability to simply choose a recent or
 * best answer from previous form submissions.
 *
 * Without the addition of the autocomplete attribute, the browser may or may
 * not offer useful suggestions. Or the browser may guess what type of data is
 * expected and offer an unsuitable list of options.
 *
 * All autocomplete attribute tokens are valid with input, select
 * (DropdownSelect), and textarea (MultiLineInput) elements.
 *
 * ####
 *
 * ✅ Pass
 *
 * `<Input type="text" id="firstName" autocomplete="given-name" label =
 * "firstName" />`
 *
 * ####
 *
 * 🛑 Fail
 *
 * `<Input type="text" id="firstName" label="firstName" />`
 *
 * ####
 *
 * Suggestion
 *
 * Provide an autocomplete attribute with the appropriate fill value that
 * describes the purpose of the form field.[Web Content Accessibility
 * Guidelines](https://www.w3.org/TR/WCAG21/#input-purposes)
 *
 * ###
 *
 * Handling focus states for screen readers
 *
 * Inputs receive default focus styling from browsers. Do not remove the focus
 * styling as it makes it hard for key-board only users to understand where they
 * are at on the webpage.
 *
 * ####
 *
 * `Autofocus` attribute on Inputs
 *
 * Automatically focusing a form control can confuse visually-impaired people
 * using screen-reading technology and people with cognitive impairments. When
 * autofocus is assigned, screen-readers "teleport" their user to the form
 * control without warning them beforehand.
 *
 * Use careful consideration for accessibility when applying the autofocus
 * attribute. Automatically focusing on a control can cause the page to scroll
 * on load. The focus can also cause dynamic keyboards to display on some touch
 * devices. While a screen reader will announce the label of the form control
 * receiving focus, the screen reader will not announce anything before the
 * label, and the sighted user on a small device will equally miss the context
 * created by the preceding content.
 *
 * ####
 *
 * Update default `focus` styling
 *
 * If you do want to update the focus styling, remove the default focus styling
 * with `outline: none` or `outline: 0`. Do not use `display: none` as this will
 * make the component invisible to the browser, making it unusable for those who
 * rely on keyboard to navigate a site. After removing the default styling
 * update the focus styling.
 *
 * ####
 *
 * Use `focus-visible` when updating focus-styling for keyboard vs mouse
 *
 * Sometimes using `:focus` styles can also have a side-effect for the user
 * experience of mouse/pointer users. Take an image gallery with previous/next
 * controls as an example. If a user clicks on one of these buttons, they will
 * get focused and therefore the focus styles will be shown. While this is great
 * for keyboard users it may be too much for mouse/pointer users.
 *
 * Do not remove `:focus` styling instead use `:focus-visible` to update styling
 * on keyboard vs mouse. The :focus-visible selector is useful to provide a
 * different focus indicator based on the user’s input modality (mouse vs.
 * keyboard).
 *
 * provide basic focus styles `button:focus { ... }` Remove focus styles for
 * mouse users `button:focus:not(:focus-visible) { outline: none; }`
 *
 * ####
 *
 * Styling the parent element of a focusable element
 *
 * The `:focus-within` CSS pseudo-class matches an element if the element or any
 * of its descendants are focused. This allows you to style parent elements with
 * `:focus styling` if the child is in focus.
 *
 * ####
 *
 * Further reading
 *
 * [Why you should use focus
 * styling](https://blog.logrocket.com/why-you-should-use-focus-styles-193d58672c5c/)
 * [Focus Control](https://reactjs.org/docs/accessibility.html#focus-control)
 * [focus-visable](https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-visible)
 * [Autofocus](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/autofocus#accessibility_considerations)
 * [focus-within](https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-within)
 *
 * Analytics
 *
 *
 * -------------
 *
 * `Input` is set up to track click and impression events:
 *
 * *   To track click events pass in an non-empty `analyticsName` (convention:
 * {appName}-{inputName})
 *
 * *   To track impression events pass: 1) a non-empty `analyticsName` 2) pass
 * `trackImpression={true}`
 *
 *
 * Input impression events will only be tracked the first time that the input
 * enters the viewport
 *
 * Events will be sent to the journey service and will end up in the
 * corresponding tables (e.g.
 * journey\_service\_production.platform\_input\_view\_event for input
 * impression events). For more information on tracking please refer
 * here:[https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update](https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update)
 */
cov_ndg0d3lom().s[1]++;
var Input = function Input(_ref) {
  var _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? (cov_ndg0d3lom().b[0][0]++, 's1') : _ref$fontSize,
    label = _ref.label,
    subtitle = _ref.subtitle,
    errorMessageProp = _ref.errorMessage,
    isInvalid = _ref.invalid,
    initialDecimalPlaces = _ref.decimalPlaces,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? (cov_ndg0d3lom().b[1][0]++, 100) : _ref$delay,
    value = _ref.value,
    onChange = _ref.onChange,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? (cov_ndg0d3lom().b[2][0]++, 'text') : _ref$type,
    _ref$unboundedWidth = _ref.unboundedWidth,
    unboundedWidth = _ref$unboundedWidth === void 0 ? (cov_ndg0d3lom().b[3][0]++, false) : _ref$unboundedWidth,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? (cov_ndg0d3lom().b[4][0]++, 'vertical') : _ref$orientation,
    min = _ref.min,
    max = _ref.max,
    customEmailValidityCheck = _ref.customEmailValidityCheck,
    labelStyles = _ref.labelStyles,
    disabled = _ref.disabled,
    helperText = _ref.helperText,
    maxLength = _ref.maxLength,
    required = _ref.required,
    placeholder = _ref.placeholder,
    analyticsName = _ref.analyticsName,
    defaultValue = _ref.defaultValue,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_ndg0d3lom().f[0]++;
  var decimalPlaces = (cov_ndg0d3lom().s[2]++, (cov_ndg0d3lom().b[6][0]++, initialDecimalPlaces) && (cov_ndg0d3lom().b[6][1]++, initialDecimalPlaces >= 0) ? (cov_ndg0d3lom().b[5][0]++, initialDecimalPlaces) : (cov_ndg0d3lom().b[5][1]++, 0));
  var _ref2 = (cov_ndg0d3lom().s[3]++, react.useState(value ? (cov_ndg0d3lom().b[7][0]++, formatValue(value, type, decimalPlaces)) : (cov_ndg0d3lom().b[7][1]++, ''))),
    _ref3 = _slicedToArray(_ref2, 2),
    content = _ref3[0],
    updateContent = _ref3[1];

  // This allows us to update the input defaultValue when the defaultValue prop changes
  // https://react.dev/reference/react-dom/components/input#controlling-an-input-with-a-state-variable
  cov_ndg0d3lom().s[4]++;
  (0,react.useEffect)(function () {
    cov_ndg0d3lom().f[1]++;
    cov_ndg0d3lom().s[5]++;
    if (!defaultValue) {
      cov_ndg0d3lom().b[8][0]++;
      cov_ndg0d3lom().s[6]++;
      return;
    } else {
      cov_ndg0d3lom().b[8][1]++;
    }
    // Added this for cases where the defaultValue is set to undefined at first but then is updated to a value
    cov_ndg0d3lom().s[7]++;
    if (content !== defaultValue) {
      cov_ndg0d3lom().b[9][0]++;
      var formattedDefaultValue = (cov_ndg0d3lom().s[8]++, formatValue(defaultValue, type, decimalPlaces));
      cov_ndg0d3lom().s[9]++;
      updateContent(formattedDefaultValue);
    } else {
      cov_ndg0d3lom().b[9][1]++;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);
  var _ref4 = (cov_ndg0d3lom().s[10]++, react.useState()),
    _ref5 = _slicedToArray(_ref4, 2),
    cursorPosition = _ref5[0],
    setCursorPosition = _ref5[1];
  var _ref6 = (cov_ndg0d3lom().s[11]++, react.useState(content)),
    _ref7 = _slicedToArray(_ref6, 2),
    setPreviousContent = _ref7[1];
  var _ref8 = (cov_ndg0d3lom().s[12]++, react.useState()),
    _ref9 = _slicedToArray(_ref8, 2),
    suggestion = _ref9[0],
    setSuggestion = _ref9[1];
  var _ref10 = (cov_ndg0d3lom().s[13]++, react.useState(!!isInvalid)),
    _ref11 = _slicedToArray(_ref10, 2),
    invalid = _ref11[0],
    setInvalid = _ref11[1];
  var _ref12 = (cov_ndg0d3lom().s[14]++, react.useState(false)),
    _ref13 = _slicedToArray(_ref12, 2),
    hasInteracted = _ref13[0],
    setHasInteracted = _ref13[1];
  var debouncedOnChange = (cov_ndg0d3lom().s[15]++, c( /*#__PURE__*/function () {
    var _ref14 = Input_asyncToGenerator( /*#__PURE__*/Input_regeneratorRuntime().mark(function _callee(e, val) {
      var unformattedValue, _ref15, valid, _suggestion;
      return Input_regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            cov_ndg0d3lom().f[2]++;
            cov_ndg0d3lom().s[16]++;
            if (!onChange) {
              _context.next = 19;
              break;
            }
            cov_ndg0d3lom().b[10][0]++;
            unformattedValue = (cov_ndg0d3lom().s[17]++, unformatValue(val, type));
            cov_ndg0d3lom().s[18]++;
            _context.next = 8;
            return checkValidity(val);
          case 8:
            _ref15 = _context.sent;
            valid = _ref15.valid;
            _suggestion = _ref15.suggestion;
            cov_ndg0d3lom().s[19]++;
            setInvalid(!valid);
            cov_ndg0d3lom().s[20]++;
            setSuggestion(_suggestion);
            cov_ndg0d3lom().s[21]++;
            onChange(e, unformattedValue, valid);
            _context.next = 20;
            break;
          case 19:
            cov_ndg0d3lom().b[10][1]++;
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref14.apply(this, arguments);
    };
  }(), delay));
  var inputRef = (cov_ndg0d3lom().s[22]++, react.useRef());
  var checkEmail = (cov_ndg0d3lom().s[23]++, customEmailValidityCheck ? (cov_ndg0d3lom().b[11][0]++, customEmailValidityCheck) : (cov_ndg0d3lom().b[11][1]++, checkEmailValidity));
  var errorMessage = (cov_ndg0d3lom().s[24]++, (cov_ndg0d3lom().b[13][0]++, required) && (cov_ndg0d3lom().b[13][1]++, isEmpty(content)) ? (cov_ndg0d3lom().b[12][0]++, ASSERT_NOT_NULL_ERROR) : (cov_ndg0d3lom().b[12][1]++, errorMessageProp));
  var isHorizontalOrientation = (cov_ndg0d3lom().s[25]++, orientation === 'horizontal');
  cov_ndg0d3lom().s[26]++;
  var useSuggestion = function useSuggestion() {
    cov_ndg0d3lom().f[3]++;
    cov_ndg0d3lom().s[27]++;
    updateContent(suggestion);
    cov_ndg0d3lom().s[28]++;
    debouncedOnChange(undefined, suggestion);
    cov_ndg0d3lom().s[29]++;
    setSuggestion(undefined);
  };
  cov_ndg0d3lom().s[30]++;
  var checkValidity = /*#__PURE__*/function () {
    var _ref16 = Input_asyncToGenerator( /*#__PURE__*/Input_regeneratorRuntime().mark(function _callee2(newValue) {
      var valid, suggestion, emailValidityResult;
      return Input_regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            cov_ndg0d3lom().f[4]++;
            valid = (cov_ndg0d3lom().s[31]++, true);
            suggestion = (cov_ndg0d3lom().s[32]++, '');
            cov_ndg0d3lom().s[33]++;
            if (newValue) {
              _context2.next = 10;
              break;
            }
            cov_ndg0d3lom().b[14][0]++;
            cov_ndg0d3lom().s[34]++;
            valid = !required;
            _context2.next = 37;
            break;
          case 10:
            cov_ndg0d3lom().b[14][1]++;
            cov_ndg0d3lom().s[35]++;
            _context2.t0 = type;
            _context2.next = _context2.t0 === 'email' ? 15 : _context2.t0 === 'tel' ? 26 : _context2.t0 === 'number' ? 31 : 36;
            break;
          case 15:
            cov_ndg0d3lom().b[15][0]++;
            cov_ndg0d3lom().s[36]++;
            _context2.next = 19;
            return checkEmail(newValue);
          case 19:
            emailValidityResult = _context2.sent;
            cov_ndg0d3lom().s[37]++;
            valid = emailValidityResult.valid;
            cov_ndg0d3lom().s[38]++;
            suggestion = emailValidityResult.suggestion;
            cov_ndg0d3lom().s[39]++;
            return _context2.abrupt("break", 37);
          case 26:
            cov_ndg0d3lom().b[15][1]++;
            cov_ndg0d3lom().s[40]++;
            valid = checkTelValidity(newValue);
            cov_ndg0d3lom().s[41]++;
            return _context2.abrupt("break", 37);
          case 31:
            cov_ndg0d3lom().b[15][2]++;
            cov_ndg0d3lom().s[42]++;
            valid = checkNumberValidity(newValue, min, max);
            cov_ndg0d3lom().s[43]++;
            return _context2.abrupt("break", 37);
          case 36:
            cov_ndg0d3lom().b[15][3]++;
          case 37:
            cov_ndg0d3lom().s[44]++;
            return _context2.abrupt("return", {
              valid: valid,
              suggestion: suggestion
            });
          case 39:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function checkValidity(_x3) {
      return _ref16.apply(this, arguments);
    };
  }();

  // we are using a string to store the input value (even for percent, number, currency) since we have a need to display commas
  cov_ndg0d3lom().s[45]++;
  var getInputMode = function getInputMode() {
    cov_ndg0d3lom().f[5]++;
    cov_ndg0d3lom().s[46]++;
    switch (type) {
      case 'email':
        cov_ndg0d3lom().b[16][0]++;
        cov_ndg0d3lom().s[47]++;
        return 'email';
      case 'tel':
        cov_ndg0d3lom().b[16][1]++;
        cov_ndg0d3lom().s[48]++;
        return 'tel';
      case 'percent':
        cov_ndg0d3lom().b[16][2]++;
      case 'number':
        cov_ndg0d3lom().b[16][3]++;
      case 'currency':
        cov_ndg0d3lom().b[16][4]++;
        cov_ndg0d3lom().s[49]++;
        return decimalPlaces > 0 ? (cov_ndg0d3lom().b[17][0]++, 'decimal') : (cov_ndg0d3lom().b[17][1]++, 'numeric');
      default:
        cov_ndg0d3lom().b[16][5]++;
        cov_ndg0d3lom().s[50]++;
        return 'text';
    }
  };
  cov_ndg0d3lom().s[51]++;
  var getType = function getType() {
    cov_ndg0d3lom().f[6]++;
    cov_ndg0d3lom().s[52]++;
    switch (type) {
      case 'password':
        cov_ndg0d3lom().b[18][0]++;
        cov_ndg0d3lom().s[53]++;
        return 'password';
      case 'email':
        cov_ndg0d3lom().b[18][1]++;
        cov_ndg0d3lom().s[54]++;
        return 'email';
      case 'tel':
        cov_ndg0d3lom().b[18][2]++;
        cov_ndg0d3lom().s[55]++;
        return 'tel';
      case 'percent':
        cov_ndg0d3lom().b[18][3]++;
        cov_ndg0d3lom().s[56]++;
        // NOTE: Number inputs intentionally have the input type of 'text'
        // to allow for formatting with commas
        return 'text';
      case 'number':
        cov_ndg0d3lom().b[18][4]++;
        cov_ndg0d3lom().s[57]++;
        // NOTE: Number inputs intentionally have the input type of 'text'
        // to allow for formatting with commas
        return 'text';
      case 'currency':
        cov_ndg0d3lom().b[18][5]++;
        cov_ndg0d3lom().s[58]++;
        // NOTE: Currency inputs intentionally have the input type of 'text'
        // to allow for formatting with commas and $
        return 'text';
      default:
        cov_ndg0d3lom().b[18][6]++;
        cov_ndg0d3lom().s[59]++;
        return 'text';
    }
  };
  cov_ndg0d3lom().s[60]++;
  var getPlaceholder = function getPlaceholder() {
    cov_ndg0d3lom().f[7]++;
    cov_ndg0d3lom().s[61]++;
    switch (type) {
      case 'email':
        cov_ndg0d3lom().b[19][0]++;
        cov_ndg0d3lom().s[62]++;
        return 'you@example.com';
      case 'tel':
        cov_ndg0d3lom().b[19][1]++;
        cov_ndg0d3lom().s[63]++;
        return '(000) 000-0000';
      case 'currency':
        cov_ndg0d3lom().b[19][2]++;
        cov_ndg0d3lom().s[64]++;
        return '$0.00';
      case 'percent':
        cov_ndg0d3lom().b[19][3]++;
        cov_ndg0d3lom().s[65]++;
        return '0.00%';
      default:
        cov_ndg0d3lom().b[19][4]++;
        cov_ndg0d3lom().s[66]++;
        return '';
    }
  };
  cov_ndg0d3lom().s[67]++;
  var getAutoCompleteAttribute = function getAutoCompleteAttribute() {
    cov_ndg0d3lom().f[8]++;
    cov_ndg0d3lom().s[68]++;
    switch (type) {
      case 'email':
        cov_ndg0d3lom().b[20][0]++;
        cov_ndg0d3lom().s[69]++;
        return 'email';
      case 'tel':
        cov_ndg0d3lom().b[20][1]++;
        cov_ndg0d3lom().s[70]++;
        return 'tel';
      default:
        cov_ndg0d3lom().b[20][2]++;
        cov_ndg0d3lom().s[71]++;
        return undefined;
    }
  };

  /*
    Manually set the cursor position for number/currency inputs. Without this, the cursor
    will always jump to the end of the input string when we add or remove commas.
  */
  cov_ndg0d3lom().s[72]++;
  (0,react.useEffect)(function () {
    cov_ndg0d3lom().f[9]++;
    cov_ndg0d3lom().s[73]++;
    if ((cov_ndg0d3lom().b[22][0]++, inputRef.current) && (cov_ndg0d3lom().b[22][1]++, cursorPosition !== undefined)) {
      cov_ndg0d3lom().b[21][0]++;
      cov_ndg0d3lom().s[74]++;
      inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
    } else {
      cov_ndg0d3lom().b[21][1]++;
    }
  }, [cursorPosition]);
  cov_ndg0d3lom().s[75]++;
  var updateNumericContent = function updateNumericContent(value, selectionStart) {
    cov_ndg0d3lom().f[10]++;
    var formatted = (cov_ndg0d3lom().s[76]++, sanitizeAndFormatNumberWithCommas(value));
    var changeInLength = (cov_ndg0d3lom().s[77]++, formatted.length - value.length);
    var newCursorPosition = (cov_ndg0d3lom().s[78]++, selectionStart + changeInLength);
    cov_ndg0d3lom().s[79]++;
    setCursorPosition(newCursorPosition > 0 ? (cov_ndg0d3lom().b[23][0]++, newCursorPosition) : (cov_ndg0d3lom().b[23][1]++, 0));
    cov_ndg0d3lom().s[80]++;
    updateContent(formatted);
  };
  cov_ndg0d3lom().s[81]++;
  var handleChange = function handleChange(e) {
    cov_ndg0d3lom().f[11]++;
    cov_ndg0d3lom().s[82]++;
    e.preventDefault();
    cov_ndg0d3lom().s[83]++;
    setHasInteracted(true);
    cov_ndg0d3lom().s[84]++;
    debouncedOnChange(e, e.currentTarget.value);
    cov_ndg0d3lom().s[85]++;
    setPreviousContent(content);
    cov_ndg0d3lom().s[86]++;
    switch (type) {
      case 'number':
        cov_ndg0d3lom().b[24][0]++;
      case 'currency':
        cov_ndg0d3lom().b[24][1]++;
        cov_ndg0d3lom().s[87]++;
        updateNumericContent(e.currentTarget.value, e.currentTarget.selectionStart);
        cov_ndg0d3lom().s[88]++;
        break;
      default:
        cov_ndg0d3lom().b[24][2]++;
        cov_ndg0d3lom().s[89]++;
        updateContent(e.currentTarget.value);
    }
  };
  cov_ndg0d3lom().s[90]++;
  var handleBlur = function handleBlur() {
    cov_ndg0d3lom().f[12]++;
    cov_ndg0d3lom().s[91]++;
    setHasInteracted(true);
    cov_ndg0d3lom().s[92]++;
    updateContent(formatValue(content, type, decimalPlaces));
  };

  // An empty required input should only be shown as invalid after the user has interacted with it
  var displayInvalid = (cov_ndg0d3lom().s[93]++, (cov_ndg0d3lom().b[25][0]++, required) && (cov_ndg0d3lom().b[25][1]++, isEmpty(content)) && (cov_ndg0d3lom().b[25][2]++, hasInteracted) || (cov_ndg0d3lom().b[25][3]++, invalid));
  cov_ndg0d3lom().s[94]++;
  return /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    className: "input-container",
    flexDirection: isHorizontalOrientation ? (cov_ndg0d3lom().b[26][0]++, 'row') : (cov_ndg0d3lom().b[26][1]++, 'column'),
    alignItems: isHorizontalOrientation ? (cov_ndg0d3lom().b[27][0]++, 'center') : (cov_ndg0d3lom().b[27][1]++, ''),
    width: ['100%', null, unboundedWidth ? (cov_ndg0d3lom().b[28][0]++, '100%') : (cov_ndg0d3lom().b[28][1]++, '350px')]
  }, ((cov_ndg0d3lom().b[29][0]++, label) || (cov_ndg0d3lom().b[29][1]++, subtitle)) && (cov_ndg0d3lom().b[29][2]++, /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    pr: isHorizontalOrientation ? (cov_ndg0d3lom().b[30][0]++, [3, 4]) : (cov_ndg0d3lom().b[30][1]++, []),
    pb: isHorizontalOrientation ? (cov_ndg0d3lom().b[31][0]++, []) : (cov_ndg0d3lom().b[31][1]++, [2, 3])
  }, (cov_ndg0d3lom().b[32][0]++, label) && (cov_ndg0d3lom().b[32][1]++, /*#__PURE__*/react.createElement(Label/* default */.Z, _extends({
    htmlFor: props.id,
    fontSize: fontSize,
    required: required,
    color: disabled ? (cov_ndg0d3lom().b[33][0]++, 'neutrals70') : (cov_ndg0d3lom().b[33][1]++, undefined)
  }, labelStyles), label)), (cov_ndg0d3lom().b[34][0]++, subtitle) && (cov_ndg0d3lom().b[34][1]++, /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    pt: 3
  }, /*#__PURE__*/react.createElement(Subtitle, {
    color: disabled ? (cov_ndg0d3lom().b[35][0]++, 'neutrals70') : (cov_ndg0d3lom().b[35][1]++, 'neutrals100')
  }, subtitle))))), /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    flex: 1,
    flexDirection: "column"
  }, /*#__PURE__*/react.createElement(InputBase/* default */.Z, _extends({
    analyticsName: analyticsName,
    "aria-disabled": disabled,
    "aria-required": required,
    "aria-invalid": displayInvalid,
    autoComplete: getAutoCompleteAttribute(),
    ref: inputRef,
    required: required,
    fontSize: fontSize,
    onChange: handleChange,
    value: content,
    type: getType(),
    inputMode: getInputMode(),
    maxLength: type === 'tel' ? (cov_ndg0d3lom().b[36][0]++, 16) : (cov_ndg0d3lom().b[36][1]++, maxLength),
    placeholder: (cov_ndg0d3lom().b[37][0]++, placeholder) || (cov_ndg0d3lom().b[37][1]++, getPlaceholder()),
    onBlur: handleBlur,
    disabled: disabled
  }, props)), (cov_ndg0d3lom().b[38][0]++, errorMessage) && (cov_ndg0d3lom().b[38][1]++, displayInvalid) && (cov_ndg0d3lom().b[38][2]++, /*#__PURE__*/react.createElement(ErrorPrompt/* default */.Z, {
    message: errorMessage
  })), (cov_ndg0d3lom().b[39][0]++, helperText) && (cov_ndg0d3lom().b[39][1]++, /*#__PURE__*/react.createElement(HelpText, null, helperText)), (cov_ndg0d3lom().b[40][0]++, suggestion) && (cov_ndg0d3lom().b[40][1]++, /*#__PURE__*/react.createElement(Suggestion, {
    suggestion: suggestion,
    useSuggestion: useSuggestion,
    fontSize: fontSize
  }))));
};
cov_ndg0d3lom().s[95]++;
var Subtitle = function Subtitle(props) {
  cov_ndg0d3lom().f[13]++;
  cov_ndg0d3lom().s[96]++;
  return /*#__PURE__*/react.createElement(Text/* default */.Z, _extends({
    fontWeight: "normal",
    size: "100",
    textAlign: "left",
    lineHeight: "100"
  }, props));
};
cov_ndg0d3lom().s[97]++;
var HelpText = function HelpText(props) {
  cov_ndg0d3lom().f[14]++;
  cov_ndg0d3lom().s[98]++;
  return /*#__PURE__*/react.createElement(Text/* default */.Z, _extends({
    fontSize: "s1",
    mt: 3,
    mb: 0
  }, props));
};
cov_ndg0d3lom().s[99]++;
var Suggestion = function Suggestion(_ref17) {
  var suggestion = _ref17.suggestion,
    useSuggestion = _ref17.useSuggestion,
    props = _objectWithoutProperties(_ref17, _excluded2);
  cov_ndg0d3lom().f[15]++;
  cov_ndg0d3lom().s[100]++;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    react.createElement(Text/* default */.Z, _extends({
      id: "input-suggestion",
      mt: 3,
      color: "brand50",
      cursor: "pointer",
      fontFamily: "sans",
      onClick: useSuggestion
    }, props), "Did you mean \"", suggestion, "\"?")
  );
};
/* harmony default export */ var Input_Input = (Input);

/***/ })

}]);